


import Utility from "../../../../utility/utility";
import ModelData from "../../../public/model_data";
import { moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import PromiseUtility from "../../../../utility/promiseUtility";
import ModuleManager from "../../../../framework/core/module_manager";
import SceneManager from "../../../../manager/scene_manager";
import GameServer from "../../../hall/server/gameserver/game_server";
import GameMorePanel from "../../../table/module/game_morepanel/game_morepanel";
import LanguageManager from "../../../../manager/language_manager";
import UserDataManager from "../../../../manager/user_manager";
import Q2TableView from "./q2_table_view";
import Q2TableModel from "./q2_table_model";
import Q2TableModuleBase from "./q2_table_module_base";
import { Q2Game } from "../../net/proto/q2_game";
import NetMessageDataQ2Game from "../../net/q2_net_msg_data_game";
import { Q2RoomInfo, Q2SeatInfo } from "./q2_table_data";
import { CardColor, Card, CardNameIndex } from "./q2_card_common";
import Q2DeskAreaCardsPattern, { SelectState } from "./q2_desk_area_cards_pattern";
import Q2SeatAreaCards from "./q2_seat_area_cards";
import Q2TablePoker from "./q2_table_poker";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import { EffectType } from "./q2_table_view_base";
import Q2TableResultModule from "../onegameresult/q2_table_result_module";
import LoaclStorage from "../../../../manager/local_storage";
import DialogLeave from "../../../public/module/dialog_leave/dialog_leave";
import { joinUtil } from "../../../public/join_util";
import TablePlayerAvatar from "../../../table/components/table_player_avatar";


const { ccclass } = cc._decorator;

const const_moduleNameList = ['ChatInfo', 'OhterChatInfo', 'Record', 'GameRule']

enum OperatType{
    None = 0,
    Raise = 1,
    Storage = 2,
    Attach = 3,
    ShowQ2 = 4,
    QuickHu = 5,
    Discard = 6,
}

@ccclass
@moduleInit("Q2TableModule")
export default class Q2TableModule extends Q2TableModuleBase<Q2TableView, Q2TableModel>  {

    

    protected m_ack_id: number = 0

    protected m_is_playing_fapai_anim: boolean = false

    protected m_operatType: OperatType = OperatType.None

    protected m_select_area: number = -1
    protected m_select_pattern_index: number = -1
    protected m_score_change_data_list: Q2Game.IScore[] = null

    protected m_last_sort_type: number = 1

    protected m_attach_hint_list: {selectCodeList: number[], selectCodeMap: any, canSelectCodeList: number[]}[] = []
    protected m_raise_hint_list: {selectCodeList: number[], selectCodeMap: any, canSelectCodeList: number[], firstCommonCardPos: number}[] = []
    protected m_storage_hint_list: {selectCodeList: number[], selectCodeMap: any, canSelectCodeList: number[], firstCommonCardPos: number}[] = []
    protected m_hint_func: ()=> {selectCodeList: number[], canSelectCodeList: number[]} = null

    protected m_last_show_module_fun: Function = null
    protected m_need_show_module_fun: Function = null

    protected m_has_show_recorder: boolean = false

    protected m_need_fadein_bgm: boolean = false

    initModule() {
        super.initModule(Q2TableView, Q2TableModel, 'package/q2/q2_table');
    }



    //重置module
    resetModule() {
        super.resetModule()

    }

    start() {
        super.start()
    }

    onInit(intentData: any) {
        super.onInit(intentData)
    }

    onHide() {
        super.onHide()
    }

    onShow(intentData) {
        // this.getRemoteRule = function(){
        //     return '{"playerCount":3}'
        // } 
        super.onShow(intentData)
        let goldData = ModelData.instance.tableCommonData.roomRuleData
        if(goldData){
            let baseScore = goldData.game_BetSingle
            let wanfaText = `${LanguageManager.t('q2_table_base_score')}: ${baseScore}`
            this.view.showWanFaLabel(true, wanfaText)
        }            
        
        // this.test()
    }

    protected onApplicationShow(isShow) {
        super.onApplicationShow(isShow)
    }

    on_destroy() {
        super.on_destroy()
        this.m_table_sound.release()
    }

    bindBtnClickEvent() {
        let self = this
        super.bindBtnClickEvent()
        this.view.buttonSortCards.node.on('click', this.on_click_sort_cards_btn, this)
    }

    unbindBtnClickEvent() {
        let self = this
        super.unbindBtnClickEvent()        
        if(!this.view){
            return
        }
        this.view.buttonSortCards.node.targetOff(this)
    }

    protected registEventMsg() {
        super.registEventMsg()
        let self = this
        self.eventBind("event_exit_game", self.on_click_menu_leave_btn);
        self.eventBind('Q2SeatAreaCards_pattern_click', self.on_click_area_pattern)
    }

    protected unregisstEventMsg() {
        super.unregisstEventMsg()
        let self = this
        self.eventUnBind("event_exit_game", self.on_click_menu_leave_btn);
        self.eventUnBind('Q2SeatAreaCards_pattern_click', self.on_click_area_pattern)
    }

    registNetMsg() {
        super.registNetMsg()
        let self = this
        self.model.subscibeMsgEvent<Q2Game.GameInfo>(NetMessageDataQ2Game.GameInfo, function (protoData) {
            self.onNetMsg_GameInfo(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.InitNotify>(NetMessageDataQ2Game.InitNotify, function (protoData) {
            self.onNetMsg_InitNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.ScoreNotify>(NetMessageDataQ2Game.ScoreNotify, function (protoData) {
            self.onNetMsg_ScoreNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.DealCardNotify>(NetMessageDataQ2Game.DealCardNotify, function (protoData) {
            self.onNetMsg_DealCardNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.MoreCardRsp>(NetMessageDataQ2Game.MoreCard, function (protoData) {
            self.onNetMsg_MoreCardRsp(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.MoreCardNotify>(NetMessageDataQ2Game.MoreCardNotify, function (protoData) {
            self.onNetMsg_MoreCardNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.MoreCardChangedNotify>(NetMessageDataQ2Game.MoreCardChangedNotify, function (protoData) {
            self.onNetMsg_MoreCardChangedNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.DiscardRsp>(NetMessageDataQ2Game.Discard, function (protoData) {
            self.onNetMsg_DiscardRsp(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.DiscardNotify>(NetMessageDataQ2Game.DiscardNotify, function (protoData) {
            self.onNetMsg_DiscardNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.SeatChangedNotify>(NetMessageDataQ2Game.SeatChangedNotify, function (protoData) {
            self.onNetMsg_SeatChangedNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.RaiseRsp>(NetMessageDataQ2Game.Raise, function (protoData) {
            self.onNetMsg_RaiseRsp(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.RaiseNotify>(NetMessageDataQ2Game.RaiseNotify, function (protoData) {
            self.onNetMsg_RaiseNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.AttachRsp>(NetMessageDataQ2Game.Attach, function (protoData) {
            self.onNetMsg_AttachRsp(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.AttachNotify>(NetMessageDataQ2Game.AttachNotify, function (protoData) {
            self.onNetMsg_AttachNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.ShowQ2Rsp>(NetMessageDataQ2Game.ShowQ2, function (protoData) {
            self.onNetMsg_ShowQ2Rsp(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.ShowQ2Notify>(NetMessageDataQ2Game.ShowQ2Notify, function (protoData) {
            self.onNetMsg_ShowQ2Notify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.StorageRsp>(NetMessageDataQ2Game.Storage, function (protoData) {
            self.onNetMsg_StorageRsp(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.StorageNotify>(NetMessageDataQ2Game.StorageNotify, function (protoData) {
            self.onNetMsg_StorageNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.CompleteRsp>(NetMessageDataQ2Game.Complete, function (protoData) {
            self.onNetMsg_CompleteRsp(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.GameSettle>(NetMessageDataQ2Game.GameSettle, function (protoData) {
            self.onNetMsg_GameSettle(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.TimeoutNotify>(NetMessageDataQ2Game.TimeoutNotify, function (protoData) {
            self.onNetMsg_TimeoutNotify(protoData)
        })

        self.model.subscibeMsgEvent<Q2Game.CardReocrderNotify>(NetMessageDataQ2Game.CardReocrderNotify, function (protoData) {
            self.onNetMsg_CardReocrderNotify(protoData)
        })

    }

    protected onNetMsg_EnterNotify(protoData: any){
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let seatInfoList = roomInfo.seatInfoList
        let lastCount = 0
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index];
            if(seatInfo.playerId){
                lastCount++
            }
        }
        super.onNetMsg_EnterNotify(protoData)
        let seatInfo = this.getSeatInfoByRemotePos(protoData.posInfo.posIndex) as Q2SeatInfo
        seatInfo.isPlaying = false
        this.view.showSeatCoinBalance(seatInfo.localPos, true, 0)
        this.view.bindSeatHandCardsUid(seatInfo.localPos, seatInfo.playerId)
        let inCount = 0
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as Q2SeatInfo
            if(seatInfo.playerId){
                inCount++
                this.view.showSeatWatchTag(seatInfo.localPos, !seatInfo.isPlaying && roomInfo.state != 0 && roomInfo.state != 6)
            }
        }
        if(roomInfo.state == 0 || roomInfo.state == 6){
            if(lastCount < roomInfo.ruleTable.pub_MinPlayerNum){                
                if(inCount >= roomInfo.ruleTable.pub_MinPlayerNum){
                    this.view.showMatchPanel(true, 4)
                }
            }
            
        }
    }

    protected onNetMsg_LeaveNotify(protoData: any){
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let seatInfoList = roomInfo.seatInfoList
        let lastCount = 0
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index];
            if(seatInfo.playerId){
                lastCount++
            }
        }
        let mySeatInfo = this.getRoomInfo().mySeatInfo
        let seatInfo = this.getSeatInfoByPlayerId(protoData.playerId)
        if (seatInfo == null) {
            this.view.showSeatHandCards(seatInfo.localPos, false)
            this.view.showSeatHandCardsBg(seatInfo.localPos, false)
        }
        if(mySeatInfo.playerId == seatInfo.playerId){
            if (joinUtil.checkLeave(protoData.reason,this)) {
                roomInfo.state = 0
                this.view.showMatchPanel(false, 0)
                this.closeServerConnect()
                return
            }
        }
        super.onNetMsg_LeaveNotify(protoData)
        if (mySeatInfo.playerId == seatInfo.playerId) {
            return
        }
        if(roomInfo.state == 0){
            if(lastCount >= roomInfo.ruleTable.pub_MinPlayerNum){
                let inCount = 0
                for (let index = 0; index < seatInfoList.length; index++) {
                    const seatInfo = seatInfoList[index];
                    if(seatInfo.playerId){
                        inCount++
                    }
                }
                if(inCount < roomInfo.ruleTable.pub_MinPlayerNum){
                    this.view.showMatchPanel(true, 1)
                }
            }
        }
    }

    protected onNetMsg_GameInfo(protoData: Q2Game.IGameInfo) {
        let self = this
        self.m_isGameInfoInited = true
        self.initSeatViewPos()
        self.initTableData(protoData)
        self.view.setIsGoldTable(self.getIsGoldTable())
        let roomInfo = self.getRoomInfo<Q2RoomInfo>()        
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        let seatInfoList = roomInfo.seatInfoList
        let wanfaText = `${LanguageManager.t('q2_table_base_score')}: ${roomInfo.ruleTable.game_BetSingle}`
        self.view.showDirectionIcon(roomInfo.state != 0, roomInfo.opDir)
        self.view.showWanFaLabel(true, wanfaText)
        self.view.showLeaveBtn(false)
        self.view.showMoreBtn(true)
        self.view.showRecordLabel(true, protoData.roundSign)
        self.view.showRoomNumLabel(true, `${LanguageManager.t('q2_table_room_id')}: ${roomInfo.roomId}`)
        self.view.showSortCardsBtn(roomInfo.state > 1)
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as Q2SeatInfo
            if (!seatInfo.userInfo) {
                self.view.showSeatInfo(seatInfo.localPos, seatInfo.playerId, function (userInfoData) {
                    seatInfo.userInfo = self.genUserInfo(userInfoData)                    
                    self.tryRefreshAllChatRecordData()
                })                
            }
            self.view.showSeatScore(seatInfo.localPos, true, seatInfo.scoreBalance)
            self.view.showSeatBankerTag(seatInfo.localPos, seatInfo.isBanker)
            self.view.showSeatWatchTag(seatInfo.localPos, !seatInfo.isPlaying && roomInfo.state != 0 && roomInfo.state != 6)
            
            self.view.showSeatClock(seatInfo.localPos, roomInfo.currentSeat == seatInfo.remotePos, roomInfo.stateExpiredTime - protoData.time, seatInfo == mySeatInfo, null, null, roomInfo.stateDuration)
            if(seatInfo == mySeatInfo){
                self.view.mySeatCards.uid = mySeatInfo.playerId
                self.view.mySeatCards.showPokers(protoData.state != 0, seatInfo.cards)
            }else{
                self.view.bindSeatHandCardsUid(seatInfo.localPos, seatInfo.playerId)
                self.view.showSeatHandCards(seatInfo.localPos, protoData.state != 0, seatInfo.cards)
                self.view.showSeatHandCardsBg(seatInfo.localPos, seatInfo.cards.length > 0)
                self.view.showSeatHandCardsCount(seatInfo.localPos, seatInfo.cards.length > 0, seatInfo.cards.length)
            }    

            //显示成牌区
            let cardPatternList = []
            for (let i = 0; i < seatInfo.finishedList.length; i++) {
                const pattern = seatInfo.finishedList[i];
                let codeList = []
                for (let j = 0; j < pattern.cards.length; j++) {
                    const code = pattern.cards[j];
                    let fullCode = code
                    let logicCode = Card.fullCodeToLogicCode(code)
                    if(!seatInfo.originalCardsMap[logicCode]){
                        let srcId = Card.codeToSrcId(code)
                        srcId = self.getLocalPosFromRemotePos(srcId, mySeatInfo.remotePos, roomInfo.maxPlayerCount) + 1
                        fullCode = Card.codeToFullCode(code, srcId)                        
                    }
                    codeList.push(fullCode)
                }
                cardPatternList.push(codeList)
            }
            self.view.showAreaCards(seatInfo.localPos, cardPatternList.length > 0, cardPatternList)

        }
        self.view.showPokerHeap(roomInfo.isRoundStarted, roomInfo.pokerHeapCount)
        self.view.mySeatCards.setCustomOnFinishDragFunc(self.onFinishClickPoker.bind(self))
        self.view.mySeatCards.setDragPokerCallback(self.onFinishDragPoker.bind(self))
        self.view.deskCards.setCustomOnFinishDragFunc(self.onFinishClickCommonPoker.bind(self))

        self.view.deskCards.showPokers(roomInfo.isRoundStarted, roomInfo.commonCards)
        
        if(roomInfo.state != 0 && roomInfo.state != 6){
            if(roomInfo.currentSeat != 0){
                let leftSecs = roomInfo.stateExpiredTime - self.getServerNowTimestamp()
                self.onSeatTurn(roomInfo.currentSeat, leftSecs, roomInfo.stateDuration)
            }            
        }
        

        self.refreshBtns()    
        self.onOperate()    

        if(roomInfo.state == 0 || roomInfo.state == 6){
            let inCount = 0
            for (let index = 0; index < seatInfoList.length; index++) {
                const seatInfo = seatInfoList[index];
                if(seatInfo.playerId){
                    inCount++
                }
            }
            if(inCount < roomInfo.ruleTable.pub_MinPlayerNum){                
                self.view.showMatchPanel(true, 1)
            }
        }
        this.eventDispatch('Game_Table_Start');
    }

    protected onNetMsg_InitNotify(protoData: Q2Game.IInitNotify){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let seatInfoList = roomInfo.seatInfoList
        this.cleanDesk(true)
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as Q2SeatInfo
            if(seatInfo.playerId){
                seatInfo.isPlaying = true
            }
            this.view.showSeatWatchTag(seatInfo.localPos, !seatInfo.isPlaying && roomInfo.state != 0 && roomInfo.state != 6)
        }
        roomInfo.opDir = protoData.opDir
        self.view.showRecordLabel(true, protoData.roundSign)
        self.view.playDirectionAnim(roomInfo.opDir, function(){
            self.view.showDirectionIcon(true, roomInfo.opDir)            
            self.model.send_ack_req(self.m_ack_id)
        })
        self.view.showMatchPanel(false, 0)
        if(self.m_need_fadein_bgm){
            self.m_table_sound.fadeInBgm()
        }
    }

    protected onNetMsg_ScoreNotify(protoData: Q2Game.IScoreNotify){
        this.m_score_change_data_list = protoData.scoreList        
    }

    protected onNetMsg_DealCardNotify(protoData: Q2Game.IDealCardNotify){
        let self = this
        self.m_last_sort_type = 1
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        roomInfo.state = 2
        roomInfo.isRoundStarted = roomInfo.state != 0
        roomInfo.pokerHeapCount = protoData.cardPoolLen
        roomInfo.firstCommonCard = protoData.firstCommonCard
        roomInfo.commonCards = []
        roomInfo.commonCards.push(roomInfo.firstCommonCard)
        Q2TablePoker.setFirstCardCode(roomInfo.firstCommonCard)
        let animList = []
        for (let index = 0; index < protoData.seatList.length; index++) {
            const element = protoData.seatList[index];
            let seatInfo = self.getSeatInfoByPlayerId(element.playerId) as Q2SeatInfo
            self.updateSeatInfo(element, seatInfo)
            let tmpFun = function(cb){
                if(seatInfo.localPos == 0){
                    self.view.mySeatCards.playFaPaiAnim(seatInfo.cards, cb, function(){
                        self.m_table_sound.playDealCardEffectSound()
                    })
                }else{
                    self.view.playSeatFaPaiAnim(seatInfo.localPos, seatInfo.cards, function(){
                        self.view.showSeatHandCardsCount(seatInfo.localPos, seatInfo.cards.length > 0, seatInfo.cards.length)
                        cb()
                    })
                    self.view.showSeatHandCardsBg(seatInfo.localPos, seatInfo.cards.length > 0)                    
                }                
            }
            animList.push(tmpFun)
        }
        self.view.showPokerHeap(roomInfo.isRoundStarted, roomInfo.pokerHeapCount)
        animList.push(function(cb){self.view.playDeskFirstCommonCardInAnim(roomInfo.firstCommonCard, cb)})
        
        PromiseUtility.all(animList).then(function(){
            self.view.showSortCardsBtn(roomInfo.state > 1)
            self.model.send_ack_req(self.m_ack_id)
        })
        this.eventDispatch('Game_Table_Start');
    }

    protected onNetMsg_MoreCardRsp(protoData: Q2Game.IMoreCardRsp){
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)     
            GameServer.instance.heartbeat_timeout_reconnect()
            return
        }
        let self = this
        self.view.showMoreCardBtn(false)
        self.view.showRaiseBtn(false)
    }

    protected onNetMsg_MoreCardNotify(protoData: Q2Game.IMoreCardNotify){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo
        roomInfo.currentSeat = protoData.seatId
        roomInfo.pokerHeapCount = protoData.cardPoolLen
        roomInfo.state = 5
        self.m_table_sound.playDealCardEffectSound()
        self.view.showPokerHeapChangeAnim(function(){
            self.view.showPokerHeap(true, roomInfo.pokerHeapCount)
        })
        if(protoData.seatId != mySeatInfo.remotePos){
            let targetSeatInfo = self.getSeatInfoByRemotePos(protoData.seatId) as Q2SeatInfo
            let code = 0
            targetSeatInfo.cards.push(code)
            self.view.playSeatHandCardInAnim(targetSeatInfo.localPos, [code], function(){
                self.view.showSeatHandCardsCount(targetSeatInfo.localPos, true, targetSeatInfo.cards.length)
                self.model.send_ack_req(self.m_ack_id)
            })
        }else{
            self.m_operatType = OperatType.None
            self.view.deskCards.resetPokers()
            self.unSelectAllAreaPattern()
        }
    }

    protected onNetMsg_MoreCardChangedNotify(protoData: Q2Game.IMoreCardChangedNotify){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        self.updateSeatInfo(protoData.seatInfo, mySeatInfo)
        self.calcHintList()
        this.view.showQuickHuCards(false)
        self.view.showQuickHuBtn(false)
        self.view.mySeatCards.resetPokers()
        self.view.mySeatCards.playCardInAnim([protoData.card], function(){
            self.model.send_ack_req(self.m_ack_id)
        })

        self.view.showMoreCardBtn(false)
        self.view.showRaiseBtn(false)
    }

    protected onNetMsg_DiscardRsp(protoData: Q2Game.IDiscardRsp){
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)     
            GameServer.instance.heartbeat_timeout_reconnect()
            return
        }
        let self = this
        self.view.showDiscardBtn(false)
        self.view.showStorageBtn(false)
        self.view.showAttachBtn(false)
    }

    protected onNetMsg_DiscardNotify(protoData: Q2Game.IDiscardNotify){
        let self = this
        this.view.showQuickHuBtn(false)
        this.view.showCancelBtn(false)
        this.view.showQuickHuCards(false)
        self.view.showDiscardBtn(false)
        self.view.showStorageBtn(false)
        self.view.showAttachBtn(false)
        self.view.showShowQ2Btn(false)

        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        roomInfo.commonCards = protoData.commonCards
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        let seatInfo = self.getSeatInfoByRemotePos(protoData.seatId) as Q2SeatInfo
        let ackId = self.m_ack_id
        if(protoData.fromCompleteProcess){
            self.view.showSeatClock(seatInfo.localPos, true, 15, seatInfo == mySeatInfo, null, null, 15)
        }
        
        let scoreChangeDataList = self.m_score_change_data_list
        self.m_score_change_data_list = null
        let onFinish = function(){           
            if(scoreChangeDataList){
                let tmpAnimList = []
                
                if(seatInfo.cards.length == 0 && seatInfo == mySeatInfo){
                    tmpAnimList.push(function(cb){
                        self.view.showMask(true)                        
                        self.playScoreChangeAnim(scoreChangeDataList, null, false, false, true, protoData.fromCompleteProcess)  
                        self.playHuPaiAnim(seatInfo, scoreChangeDataList, function(){
                            self.view.showMask(false)
                            cb()
                        }, protoData.fromCompleteProcess)   
                        self.m_table_sound.fadeOutBgm()
                        self.m_need_fadein_bgm = true
                    })                    
                } else{
                    tmpAnimList.push(function(cb){                        
                        self.playScoreChangeAnim(scoreChangeDataList, null, false, false, true, protoData.fromCompleteProcess)     
                        self.playScoreChangeAnim(scoreChangeDataList, cb, false, false, false, protoData.fromCompleteProcess)                                          
                    })
                }
                if(seatInfo.cards.length == 0){
                    self.view.showSeatClock(seatInfo.localPos, false)
                }
                PromiseUtility.all(tmpAnimList).then(function(){
                    self.playScoreChangeAnim(scoreChangeDataList, function(){
                        self.playScoreChangeAnim(scoreChangeDataList, function(){
                            self.model.send_ack_req(ackId)                           
                        }, false, true, false, protoData.fromCompleteProcess)
                    }, true, false, false, protoData.fromCompleteProcess)
                    
                })
            }else{
                self.model.send_ack_req(ackId)
            }                      
        }
        if(mySeatInfo.remotePos == protoData.seatId){
            self.m_operatType = OperatType.None
            self.setAllNormalState()          
            self.view.mySeatCards.playCardOutAnim([protoData.card])
            self.removeCodesFromList(seatInfo.cards, [protoData.card])
        }else{
            let outCodeList = []
            if(seatInfo.showQ2 && Card.isQ2(protoData.card)){
                outCodeList.push(protoData.card)
            }else{
                outCodeList.push(0)
            }
            self.removeCodesFromList(seatInfo.cards, outCodeList)

            self.view.playSeatHandCardOutAnim(seatInfo.localPos, outCodeList, function(){
                self.view.showSeatHandCardsCount(seatInfo.localPos, true, seatInfo.cards.length)
            })
        }
        let isMale = seatInfo.userInfo && seatInfo.userInfo.gender == 1
        
        let playCommonDeskPokerIn = function(onFinish){
            self.view.playDeskCommonCardInAnim([roomInfo.commonCards[roomInfo.commonCards.length - 1]], onFinish)
        }
        if(seatInfo.cards.length == 0){
            self.m_table_sound.playShowWinCardEffectSound()
            self.view.playSeatHuPokerAnim(seatInfo.localPos, protoData.card, function(){
                playCommonDeskPokerIn(onFinish)
            }, seatInfo.playerId)
        }else{
            self.m_table_sound.playCardTypeSound(isMale, 1, Card.codeToIndex(protoData.card))
            self.m_table_sound.playDiscardEffectSound()
            playCommonDeskPokerIn(onFinish)
        }
        
    }

    protected onNetMsg_SeatChangedNotify(protoData: Q2Game.ISeatChangedNotify){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        self.updateSeatInfo(protoData.seatInfo, mySeatInfo)
        self.calcHintList()
    }

    protected onNetMsg_RaiseRsp(protoData: Q2Game.IRaiseRsp){
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)     
            GameServer.instance.heartbeat_timeout_reconnect()
            return
        }
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        self.updateSeatInfo(protoData.seatInfo, mySeatInfo)
        self.calcHintList()
        self.view.showConfirmBtn(false)
        self.view.showCancelBtn(false)
        self.view.showHintBtn(false)
    }

    protected onNetMsg_RaiseNotify(protoData: Q2Game.IRaiseNotify){
        let self = this        
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        let seatInfo = self.getSeatInfoByRemotePos(protoData.seatId) as Q2SeatInfo
        if(seatInfo != mySeatInfo){
            seatInfo.finishedList.push(protoData.pattern)
            for (let j = 0; j < protoData.pattern.origCards.length; j++) {
                const code = protoData.pattern.origCards[j];
                let logicCode = Card.codeToLogicCode(code)
                seatInfo.originalCardsMap[logicCode] = logicCode
            }
        }else{
            self.m_hint_func = null
        }
        
        if(protoData.fromCompleteProcess){
            self.view.showSeatClock(seatInfo.localPos, true, 15, seatInfo == mySeatInfo, null, null, 15)
        }

        let lastCommonCards = roomInfo.commonCards.concat()
        roomInfo.commonCards = protoData.commonCards
        let commonOutCodeList = self.findExcludeCodeList(lastCommonCards, roomInfo.commonCards)        

        let scoreChangeDataList = self.m_score_change_data_list
        self.m_score_change_data_list = null
        let onFinish = function(){
            if(scoreChangeDataList){
                self.playScoreChangeAnim(scoreChangeDataList, function(){
                    self.model.send_ack_req(self.m_ack_id)
                }, false, false, false, protoData.fromCompleteProcess)  
            }else{
                self.model.send_ack_req(self.m_ack_id)
            }                      
        }
        let animList = []
        if(mySeatInfo.remotePos == protoData.seatId){
            self.m_operatType = OperatType.None
            self.setAllNormalState()
            let tmpData = self.filterCodeListBySrcId(protoData.pattern.cards, [mySeatInfo.remotePos])
            animList.push(function(cb){
                self.view.mySeatCards.playCardOutAnim(tmpData.includeList, cb)
            })
            
            let cards = self.view.mySeatCards.getCodeList()
            let myHandInCards = this.findExcludeCodeList(mySeatInfo.cards, cards)
            if(myHandInCards.length > 0){
                animList.push(function(cb){
                    self.view.mySeatCards.playCardInAnim(myHandInCards, cb)
                })
            }
            
        }else{
            let lastCards = seatInfo.cards
            seatInfo.cards = protoData.cards            
            
            let tmpData = self.filterCodeListBySrcId(protoData.pattern.cards, [seatInfo.remotePos])
            let outCodeList = []
            let inCodeList = self.findExcludeCodeList(commonOutCodeList, protoData.pattern.cards)

            for (let index = 0; index < inCodeList.length; index++) {
                const tmpCode = inCodeList[index];
                if(seatInfo.showQ2 && Card.isQ2(tmpCode)){
                    
                }else{
                    inCodeList[index] = 0
                }  
            }
            for (let index = 0; index < tmpData.includeList.length; index++) {     
                let code = tmpData.includeList[index]           
                if(seatInfo.showQ2 && Card.isQ2(code)){
                    outCodeList.push(code)
                }else{
                    outCodeList.push(0)
                }                
            }
            animList.push(function(cb){
                self.view.playSeatHandCardOutAnim(seatInfo.localPos, outCodeList, function(){
                    if(inCodeList.length > 0){
                        self.view.playSeatHandCardInAnim(seatInfo.localPos, inCodeList, function(){
                            self.view.showSeatHandCardsCount(seatInfo.localPos, true, seatInfo.cards.length)    
                            cb()
                        })
                    }else{
                        self.view.showSeatHandCardsCount(seatInfo.localPos, true, seatInfo.cards.length)
                        cb()
                    }                
                })
            })
            
        }
        self.setAllNormalState()

        self.view.playDeskCommonCardOutAnim(commonOutCodeList)
        let targetIndex = seatInfo.finishedList.length - 1
        animList.push(function(cb){
            self.view.playAreaCardsInAnim(seatInfo.localPos, targetIndex, protoData.pattern.cards, cb, {codeList: protoData.pattern.cards, type: 1, fromCompleteProcess: protoData.fromCompleteProcess})  
        })
        
        let isMale = seatInfo.userInfo && seatInfo.userInfo.gender == 1
        self.m_table_sound.playRaiseSound(isMale)  
        self.m_table_sound.playChengPaiEffectSound()

        if(scoreChangeDataList){
            self.playScoreChangeAnim(scoreChangeDataList, null, false, false, true, protoData.fromCompleteProcess)
        }
        PromiseUtility.all(animList).then(function(){
            onFinish && onFinish()
        })
    }

    protected onNetMsg_AttachRsp(protoData: Q2Game.IAttachRsp){
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)     
            GameServer.instance.heartbeat_timeout_reconnect()
            return
        }
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        self.updateSeatInfo(protoData.seatInfo, mySeatInfo)
        self.calcHintList()
        self.view.showConfirmBtn(false)
        self.view.showCancelBtn(false)
        self.view.showHintBtn(false)
    }

    protected onNetMsg_AttachNotify(protoData: Q2Game.IAttachNotify){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        let seatInfo = self.getSeatInfoByRemotePos(protoData.seatId) as Q2SeatInfo
        let targetSeatInfo = self.getSeatInfoByRemotePos(protoData.targetSeat) as Q2SeatInfo

        if(mySeatInfo.remotePos != protoData.seatId || mySeatInfo.remotePos != protoData.targetSeat){
            let tmpPatterns = self.findPatternsInList(targetSeatInfo.finishedList, protoData.pattern.cards)
            let tmpData = tmpPatterns.includeList[0]
            targetSeatInfo.finishedList[tmpData.index] = protoData.pattern
            for (let j = 0; j < protoData.pattern.origCards.length; j++) {
                const code = protoData.pattern.origCards[j];
                let logicCode = Card.codeToLogicCode(code)
                targetSeatInfo.originalCardsMap[logicCode] = logicCode
            }
        }

        if(protoData.fromCompleteProcess){
            self.view.showSeatClock(seatInfo.localPos, true, 15, seatInfo == mySeatInfo, null, null, 15)
        }

        let scoreChangeDataList = self.m_score_change_data_list
        self.m_score_change_data_list = null
        let onFinish = function(){
            if(scoreChangeDataList){
                self.playScoreChangeAnim(scoreChangeDataList, function(){
                    self.model.send_ack_req(self.m_ack_id)
                }, false, false, false, protoData.fromCompleteProcess)  
            }else{
                self.model.send_ack_req(self.m_ack_id)
            }                      
        }
        let animList = []
        if(mySeatInfo.remotePos == protoData.seatId){
            self.m_operatType = OperatType.None
            self.m_hint_func = null
            let outCodeList = [protoData.card]
            self.setAllNormalState()
            let tmpFun = function(cb){
                self.view.mySeatCards.playCardOutAnim(outCodeList, cb)            
            }
            animList.push(tmpFun)
        }else{
            let outCodeList = [0]
            if(seatInfo.showQ2 && Card.isQ2(protoData.card)){
                outCodeList[0] = protoData.card
            }
            self.removeCodesFromList(seatInfo.cards, outCodeList)

            let tmpFun = function(cb){
                self.view.playSeatHandCardOutAnim(seatInfo.localPos, outCodeList, function(){
                    self.view.showSeatHandCardsCount(seatInfo.localPos, true, seatInfo.cards.length)
                    cb()
                })
            }
            animList.push(tmpFun)
        }
        let tmpPatterns = self.findPatternsInList(targetSeatInfo.finishedList, protoData.pattern.cards)
        let tmpData = tmpPatterns.includeList[0]
        let targetIndex = tmpData.index
        let areaIndex = self.getLocalPosFromRemotePos(seatInfo.remotePos, mySeatInfo.remotePos, roomInfo.maxPlayerCount) + 1
        let attachCode = Card.codeToFullCode(protoData.card, areaIndex)
        let tmpFun = function(cb){
            self.view.playAreaCardsInAnim(targetSeatInfo.localPos, targetIndex, [attachCode], cb, {codeList: protoData.pattern.cards, type: 3, fromCompleteProcess: protoData.fromCompleteProcess})
        }
        animList.push(tmpFun)
        let isMale = seatInfo.userInfo && seatInfo.userInfo.gender == 1
        self.m_table_sound.playAttachSound(isMale)  
        self.m_table_sound.playChengPaiEffectSound()
        if(scoreChangeDataList){
            self.playScoreChangeAnim(scoreChangeDataList, null, false, false, true, protoData.fromCompleteProcess)
        }
        PromiseUtility.all(animList).then(function(){
            onFinish && onFinish()
        })
    }

    protected onNetMsg_ShowQ2Rsp(protoData: Q2Game.IShowQ2Rsp){
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)     
            GameServer.instance.heartbeat_timeout_reconnect()
            return
        }
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        mySeatInfo.canShowQ2 = false    
    }

    protected onNetMsg_ShowQ2Notify(protoData: Q2Game.IShowQ2Notify){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo

        let scoreChangeDataList = self.m_score_change_data_list
        self.m_score_change_data_list = null
        let onFinish = function(){
            if(scoreChangeDataList){
                self.playScoreChangeAnim(scoreChangeDataList, function(){
                    self.model.send_ack_req(self.m_ack_id)
                })  
            }else{
                self.model.send_ack_req(self.m_ack_id)
            }                      
        }

        let seatInfo = self.getSeatInfoByRemotePos(protoData.seatId) as Q2SeatInfo
        seatInfo.showQ2 = true
        if(protoData.seatId == mySeatInfo.remotePos){            
            
        }else{
            seatInfo.cards[0] = Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_Q)
            seatInfo.cards[1] = Card.colorIndexToCode(CardColor.color_plum, CardNameIndex.card_2)
            self.view.showSeatHandCards(seatInfo.localPos, true, seatInfo.cards)
        }
        onFinish()
    }

    protected onNetMsg_StorageRsp(protoData: Q2Game.IStorageRsp){
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)     
            GameServer.instance.heartbeat_timeout_reconnect()
            return
        }
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        self.updateSeatInfo(protoData.seatInfo, mySeatInfo)
        self.calcHintList()
        self.view.showCancelBtn(false)
        self.view.showConfirmBtn(false)
        self.view.showHintBtn(false)
    }

    protected onNetMsg_StorageNotify(protoData: Q2Game.IStorageNotify){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        let seatInfo = self.getSeatInfoByRemotePos(protoData.seatId) as Q2SeatInfo
        if(seatInfo != mySeatInfo){
            seatInfo.finishedList.push(protoData.pattern)
            for (let j = 0; j < protoData.pattern.origCards.length; j++) {
                const code = protoData.pattern.origCards[j];
                let logicCode = Card.codeToLogicCode(code)
                seatInfo.originalCardsMap[logicCode] = logicCode
            }            
        }
        if(protoData.fromCompleteProcess){
            self.view.showSeatClock(seatInfo.localPos, true, 15, seatInfo == mySeatInfo, null, null, 15)
        }
        let scoreChangeDataList = self.m_score_change_data_list
        self.m_score_change_data_list = null
        let onFinish = function(){
            if(scoreChangeDataList){
                self.playScoreChangeAnim(scoreChangeDataList, function(){
                    self.model.send_ack_req(self.m_ack_id)
                }, false, false, false, protoData.fromCompleteProcess)  
            }else{
                self.model.send_ack_req(self.m_ack_id)
            }                      
        }

        let animList = []
        if(mySeatInfo.remotePos == protoData.seatId){
            self.m_operatType = OperatType.None
            self.m_hint_func = null
            self.setAllNormalState()
            let tmpFun = function(cb){
                self.view.mySeatCards.playCardOutAnim(protoData.pattern.cards, cb)
            }
            animList.push(tmpFun)
        }else{
            let outCodeList = []
            for (let index = 0; index < protoData.pattern.cards.length; index++) {   
                let code = protoData.pattern.cards[index]
                if(seatInfo.showQ2 && Card.isQ2(code)){
                    outCodeList.push(code)
                }else{
                    outCodeList.push(0)
                }                          
            }
            self.removeCodesFromList(seatInfo.cards, outCodeList)
            let tmpFun = function(cb){
                self.view.playSeatHandCardOutAnim(seatInfo.localPos, outCodeList, function(){
                    self.view.showSeatHandCardsCount(seatInfo.localPos, true, seatInfo.cards.length)
                    cb()
                })
            }
            animList.push(tmpFun)
        }
        
        let targetIndex = seatInfo.finishedList.length - 1
        animList.push(function(cb){self.view.playAreaCardsInAnim(seatInfo.localPos, targetIndex, protoData.pattern.cards, cb, {codeList: protoData.pattern.cards, type: 2, fromCompleteProcess: protoData.fromCompleteProcess})})
        let isMale = seatInfo.userInfo && seatInfo.userInfo.gender == 1
        self.m_table_sound.playStorageSound(isMale)  
        self.m_table_sound.playChengPaiEffectSound()
        if(scoreChangeDataList){
            self.playScoreChangeAnim(scoreChangeDataList, null, false, false, true, protoData.fromCompleteProcess)
        }
        PromiseUtility.all(animList).then(function(){
            onFinish && onFinish()
        })
    }

    protected onNetMsg_CompleteRsp(protoData: Q2Game.ICompleteRsp){
        if(protoData.errNo){   
            this.on_msg_err(protoData.errNo)     
            GameServer.instance.heartbeat_timeout_reconnect()
            return
        }
        this.view.showQuickHuBtn(false)
        this.view.showCancelBtn(false)
        this.view.showQuickHuCards(false)
    }

    protected onFinishDragPoker(pokers: PokerTablePokerBase[]){
        let codeList = []
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            let code = Card.fullCodeToCode(poker.code)
            codeList.push(code)
        }
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        mySeatInfo.cards = codeList
        this.model.send_cards_sequence_change_req(codeList)
    }

    protected calcHintList(){
        let roomInfo = this.getRoomInfo<Q2RoomInfo>()
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        let raisableList = mySeatInfo.raisableList
        let storableList = mySeatInfo.storableList
        let commonCards = roomInfo.commonCards
        let commonCardsPosMap = {}
        for (let index = 0; index < commonCards.length; index++) {
            const code = commonCards[index];
            commonCardsPosMap[code] = index
        }
        let hintList = this.m_raise_hint_list = []
        let canSelectCodeList: number[] = []
        for (let i = 0; i < raisableList.length; i++) {
            const pattern = raisableList[i];
            let cardList: Card[] = []
            let indexMap = {}
            for (let index = 0; index < pattern.cards.length; index++) {
                const code = pattern.cards[index];
                let card = Card.makeCardByCode(code)
                indexMap[card.index] = card
                cardList.push(card)
                canSelectCodeList.push(card.code)
            }
            if(pattern.type == 2){  //同花顺                
                if(indexMap[CardNameIndex.card_A] && indexMap[CardNameIndex.card_K]){
                    cardList.sort(function(a, b){
                        return a.logicIndex - b.logicIndex
                    })
                }else{
                    cardList.sort(function(a, b){
                        return a.index - b.index
                    })
                }
                
            }else{
                cardList.sort(function(a, b){
                    return a.color - b.color
                })
            }
            for (let i = 0; i <= cardList.length - 3; i++) {                    
                for (let j = 3; j <= cardList.length; j++) {
                    let tmpCodeList = []
                    let tmpCodeMap = {}
                    let commonCount = 0
                    let handsCount = 0
                    let firstCommonCardPos = 0
                    for (let k = 0; k < j && i + k < cardList.length; k++) {
                        let card = cardList[i + k]
                        if(card.srcId == 0){
                            commonCount++
                            if(firstCommonCardPos > commonCardsPosMap[card.code]){
                                firstCommonCardPos = commonCardsPosMap[card.code]
                            }
                        }else{
                            handsCount++
                        }
                        tmpCodeList.push(card.code)
                        tmpCodeMap[card.code] = card.code
                    }
                    if(commonCount > 0 && handsCount > 0){
                        hintList.push({selectCodeList: tmpCodeList, selectCodeMap: tmpCodeMap, canSelectCodeList: canSelectCodeList, firstCommonCardPos: firstCommonCardPos})
                    }
                }
                
            }
        }

        hintList = this.m_storage_hint_list = []
        canSelectCodeList = []
        for (let i = 0; i < storableList.length; i++) {
            const pattern = storableList[i];
            let cardList: Card[] = []
            let indexMap = {}
            for (let index = 0; index < pattern.cards.length; index++) {
                const code = pattern.cards[index];
                let card = Card.makeCardByCode(code)
                indexMap[card.index] = card
                cardList.push(card)
                canSelectCodeList.push(card.code)
            }
            if(pattern.type == 2){  //同花顺                
                if(indexMap[CardNameIndex.card_A] && indexMap[CardNameIndex.card_K]){
                    cardList.sort(function(a, b){
                        return a.logicIndex - b.logicIndex
                    })
                }else{
                    cardList.sort(function(a, b){
                        return a.index - b.index
                    })
                }
                
            }else{
                cardList.sort(function(a, b){
                    return a.color - b.color
                })
            }
            for (let i = 0; i <= cardList.length - 3; i++) {                    
                for (let j = 3; j <= cardList.length; j++) {
                    let tmpCodeList = []
                    let tmpCodeMap = {}
                    for (let k = 0; k < j && i + k < cardList.length; k++) {
                        let card = cardList[i + k]                       
                        tmpCodeList.push(card.code)
                        tmpCodeMap[card.code] = card.code
                    }
                    hintList.push({selectCodeList: tmpCodeList, selectCodeMap: tmpCodeMap, canSelectCodeList: canSelectCodeList, firstCommonCardPos: 0})
                }
                
            }
        }
    }

    protected autoHint(clickPoker: PokerTablePokerBase, lastSelectedPokerList: PokerTablePokerBase[], storage?: boolean){
        if(!clickPoker){
            return
        }
        let codeMap = {}
        let lastCodeList = []
        let pokerIsInList = false
        for (let index = 0; index < lastSelectedPokerList.length; index++) {
            const poker = lastSelectedPokerList[index];
            codeMap[poker.code] = poker
            lastCodeList.push(poker.code)
            if(clickPoker.code == poker.code){
                pokerIsInList = true
            }
        }
        let hintList = storage? this.m_storage_hint_list : this.m_raise_hint_list
        if(pokerIsInList){
            let availableList = []
            let maxLenData = null
            let minLenData = null
            let minFirstData = null
            for (let index = 0; index < hintList.length; index++) {
                const data = hintList[index];
                if(data.selectCodeMap[clickPoker.code]){
                    continue
                }
                let isOk = true
                for (let i = 0; i < data.selectCodeList.length; i++) {
                    const code = data.selectCodeList[i];
                    if(!codeMap[code]){
                        isOk = false
                        break
                    }
                }
                if(isOk){
                    availableList.push(data)
                    if(!maxLenData){
                        maxLenData = data
                    }
                    if(maxLenData.selectCodeList.length < data.selectCodeList.length){
                        maxLenData = data
                    }
                    if(!minLenData){
                        minLenData = data
                    }
                    if(minLenData.selectCodeList.length > data.selectCodeList.length){
                        minLenData = data
                    }
                    if(!minFirstData){
                        minFirstData = data
                    }
                    if(data.firstCommonCardPos < minFirstData.firstCommonCardPos){
                        minFirstData = data
                    }
                }
            }
            //选择选中中最大数量的牌组合
            if(maxLenData){
                let selectCodeList = maxLenData.selectCodeList
                this.view.mySeatCards.selectPokers(selectCodeList, null)
                this.view.mySeatCards.refreshPokerSelectState(false)
                this.view.deskCards.selectPokers(selectCodeList, null)
                this.view.deskCards.refreshPokerSelectState(false)
            }
        }else{
            let maxLenData = null
            let maxCount = 0
            for (let index = 0; index < hintList.length; index++) {
                const data = hintList[index];
                if(!data.selectCodeMap[clickPoker.code]){
                    continue
                }
                let count = 0
                for (let i = 0; i < lastCodeList.length; i++) {
                    let code = lastCodeList[i]
                    if(data.selectCodeMap[code]){
                        count++
                    }
                }
                maxLenData = maxLenData || data
                if(count > maxCount){
                    maxCount = count
                    maxLenData = data
                }else if(count == maxCount){
                    if(maxLenData.firstCommonCardPos > data.firstCommonCardPos){
                        maxLenData = data
                    }else if(maxLenData.firstCommonCardPos == data.firstCommonCardPos){
                        if(data.selectCodeList.length < maxLenData.selectCodeList.length){
                            maxLenData = data
                        }
                    }
                }
            }
            //选择选中中最大数量的牌组合
            if(maxLenData){
                let selectCodeList = maxLenData.selectCodeList
                this.view.mySeatCards.selectPokers(selectCodeList, null)
                this.view.mySeatCards.refreshPokerSelectState(false)
                this.view.deskCards.selectPokers(selectCodeList, null)
                this.view.deskCards.refreshPokerSelectState(false)
            }
        }
    }

    protected onFinishClickCommonPoker(){
        let self = this
        let roomInfo = self.getRoomInfo<Q2RoomInfo>()
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo    
        if(roomInfo.currentSeat == mySeatInfo.remotePos){  
            if(self.m_operatType == OperatType.Raise){
                self.m_table_sound.playClickPokerEffectSound()
                let lastSelectData = self.view.deskCards.getSelectedPokers() 
                self.view.deskCards.refreshPokerSelectState(false)   
                let selectData = self.view.mySeatCards.getSelectedPokers()
                let deskSelectData = self.view.deskCards.getSelectedPokers()
                let selectPoker = null
                let tmpPokerList = this.findExcludePokerList(deskSelectData.real_selected_pokerList, lastSelectData.real_selected_pokerList)
                if(tmpPokerList.length == 1){
                    selectPoker = tmpPokerList[0]
                }else if(tmpPokerList.length == 0){
                    tmpPokerList = this.findExcludePokerList(lastSelectData.real_selected_pokerList, deskSelectData.real_selected_pokerList)
                    if(tmpPokerList.length == 1){
                        selectPoker == tmpPokerList[0]
                    }else{
                        console.error('tmpPokerList.length should equal 1', tmpPokerList, lastSelectData.real_selected_pokerList, deskSelectData.real_selected_pokerList)
                        return
                    }
                }else{
                    console.error('tmpPokerList.length should not large than 1', tmpPokerList)
                    return
                }
                if(selectPoker && deskSelectData.real_selected_pokerList.length > 0){
                    this.autoHint(selectPoker, selectData.real_selected_pokerList.concat(lastSelectData.real_selected_pokerList))
                    selectData = self.view.mySeatCards.getSelectedPokers()
                    deskSelectData = self.view.deskCards.getSelectedPokers()
                }
                
                let inCodeList = self.findCommonComingHandCards(roomInfo.commonCards, deskSelectData.real_selected_codeList)
                let canRaise = self.canRaise(deskSelectData.real_selected_codeList, selectData.real_selected_codeList) && mySeatInfo.cards.length + inCodeList.length > selectData.real_selected_codeList.length
                self.view.showConfirmBtn(true, !canRaise, !canRaise)
                return
            }
        }
        

    }

    protected onFinishClickPoker(){
        let self = this
        let roomInfo = self.getRoomInfo<Q2RoomInfo>()
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo    
        let lastSelectData = self.view.mySeatCards.getSelectedPokers() 
        self.view.mySeatCards.refreshPokerSelectState(false)      
        self.m_table_sound.playClickPokerEffectSound()
        if(!self.m_is_playing_fapai_anim && roomInfo.currentSeat == mySeatInfo.remotePos){             
            if(self.m_operatType == OperatType.Attach){
                let selectData = self.view.mySeatCards.getSelectedPokers()                
                if(selectData.real_selected_codeList.length == 0){
                    self.view.mySeatCards.selectPokers(lastSelectData.real_selected_codeList, null)
                    self.view.mySeatCards.refreshPokerSelectState(false) 
                    selectData = lastSelectData
                }else{
                    if(selectData.real_selected_codeList.length != lastSelectData.real_selected_codeList.length){
                        selectData.real_selected_pokerList.sort(function(a, b){
                            return b.selected_time - a.selected_time
                        })
                        let selectCodes = [selectData.real_selected_pokerList[0].code]
                        let tmpData = self.getSelectCodesAndCanSelectCodes(selectCodes)
                        self.selectCards(tmpData.selectCodeList, tmpData.canSelectCodeList)
                    }
                }
            }
            if(self.m_operatType == OperatType.Discard){
                let selectData = self.view.mySeatCards.getSelectedPokers()                
                if(selectData.real_selected_codeList.length > 1){
                    selectData.real_selected_pokerList.sort(function(a, b){
                        return b.selected_time - a.selected_time
                    })
                    let selectCodes = [selectData.real_selected_pokerList[0].code]
                    self.view.mySeatCards.selectPokers(selectCodes, null)
                    self.view.mySeatCards.refreshPokerSelectState(false)                     
                }
            }
            if(self.m_operatType == OperatType.Raise || self.m_operatType == OperatType.Storage){
                let selectData = self.view.mySeatCards.getSelectedPokers()
                let deskSelectData = self.view.deskCards.getSelectedPokers()
                let selectPoker = null
                let tmpPokerList = this.findExcludePokerList(selectData.real_selected_pokerList, lastSelectData.real_selected_pokerList)
                if(tmpPokerList.length == 1){
                    selectPoker = tmpPokerList[0]
                }else if(tmpPokerList.length == 0){
                    tmpPokerList = this.findExcludePokerList(lastSelectData.real_selected_pokerList, selectData.real_selected_pokerList)
                    if(tmpPokerList.length == 1){
                        selectPoker == tmpPokerList[0]
                    }else{
                        console.error('tmpPokerList.length should equal 1', tmpPokerList, lastSelectData.real_selected_pokerList, selectData.real_selected_pokerList)
                        return
                    }
                }else{
                    console.error('tmpPokerList.length should not large than 1', tmpPokerList)
                    return
                }
                if(selectPoker && selectData.real_selected_pokerList.length > 0){
                    this.autoHint(selectPoker, deskSelectData.real_selected_pokerList.concat(lastSelectData.real_selected_pokerList), self.m_operatType == OperatType.Storage)
                }
            }
            self.checkActionBtnState()
        }        
    }
    
    protected checkActionBtnState(){
        let self = this
        let roomInfo = self.getRoomInfo<Q2RoomInfo>()
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo 
        self.view.showBtnTips(false)
        if(self.m_operatType == OperatType.Raise){
            let selectData = self.view.mySeatCards.getSelectedPokers()
            let deskSelectData = self.view.deskCards.getSelectedPokers()
            let inCodeList = self.findCommonComingHandCards(roomInfo.commonCards, deskSelectData.real_selected_codeList)
            let canRaise = self.canRaise(deskSelectData.real_selected_codeList, selectData.real_selected_codeList) && mySeatInfo.cards.length + inCodeList.length > selectData.real_selected_codeList.length
            if(!canRaise){
                self.view.showBtnTips(true, LanguageManager.t('q2_table_tips_cannot_raise', true), self.getNodeWorldPos(self.view.buttonConfirm.node))
            }
            self.view.showConfirmBtn(true, !canRaise, !canRaise)
            return
        }
        if(self.m_operatType == OperatType.Attach){
            let selectData = self.view.mySeatCards.getSelectedPokers()
            let seatInfo = self.getSeatInfoByLocalPos(self.m_select_area) as Q2SeatInfo                
            let canAttach = self.canAttach(seatInfo.finishedList[self.m_select_pattern_index].cards, selectData.real_selected_codeList[0]) && mySeatInfo.cards.length != selectData.real_selected_codeList.length
            if(!canAttach){
                self.view.showBtnTips(true, LanguageManager.t('q2_table_tips_cannot_attach', true), self.getNodeWorldPos(this.view.buttonConfirm.node))
            }
            self.view.showConfirmBtn(true, !canAttach, !canAttach)
            return
        }
        if(self.m_operatType == OperatType.Storage){
            let selectData = self.view.mySeatCards.getSelectedPokers()
            let canStorage = self.canStorage(selectData.real_selected_codeList) && mySeatInfo.cards.length != selectData.real_selected_codeList.length
            if(!canStorage){
                self.view.showBtnTips(true, LanguageManager.t('q2_table_tips_cannot_storage', true), self.getNodeWorldPos(this.view.buttonConfirm.node))
            }
            self.view.showConfirmBtn(true, !canStorage, !canStorage)
            return
        }
        if(self.m_operatType == OperatType.Discard){
            self.view.showDiscardBtn(true)
            let selectData = self.view.mySeatCards.getSelectedPokers()
            if(selectData.real_selected_codeList.length > 1){
                self.view.showBtnTips(true, LanguageManager.t('q2_table_tips_select_one', true), self.getNodeWorldPos(this.view.buttonDiscard.node))
                return
            }else if(selectData.real_selected_codeList.length < 1){            
                self.view.showBtnTips(true, LanguageManager.t('q2_table_tips_select_one', true), self.getNodeWorldPos(this.view.buttonDiscard.node))
                return
            }
            let code = selectData.real_selected_codeList[0]
            let isDummy = self.findPatternsInList(mySeatInfo.attachableList, [code]).includeList.length > 0
            if(isDummy){
                self.view.showBtnTips(true, LanguageManager.t('q2_table_tips_dummy_cards', true), self.getNodeWorldPos(this.view.buttonDiscard.node))
                return
            }

            let diuChengPai = self.isDiuChengPai(roomInfo.commonCards, code)
            if(diuChengPai){
                self.view.showBtnTips(true, LanguageManager.t('q2_table_tips_cheng_cards', true), self.getNodeWorldPos(this.view.buttonDiscard.node))
                return
            }
        }
    }

    protected findPatternsInList(patternList: Q2Game.ICardPattern[], codeList: number[], allInclude?: boolean): {includeList: {pattern: Q2Game.ICardPattern, index: number}[], excludeList: {pattern: Q2Game.ICardPattern, index: number}[]}{
        let tmpMap = {}        
        for (let index = 0; index < codeList.length; index++) {
            const code = codeList[index];
            let logicCode = Card.codeToLogicCode(code)
            tmpMap[logicCode] = true
        }
        let includeList = []
        let excludeList = []
        for (let i = 0; i < patternList.length; i++) {
            const element = patternList[i];
            let include = false
            let allIn = true
            for (let j = 0; j < element.cards.length; j++) {
                const code = element.cards[j];
                let logicCode = Card.codeToLogicCode(code)
                if(allInclude){
                    if(!tmpMap[logicCode]){
                        allIn = false
                        break
                    }
                }else{
                    if(tmpMap[logicCode]){
                        include = true                    
                        break             
                    }
                }
                
            }
            if(allInclude){
                if(allIn){
                    includeList.push({pattern: element, index: i})  
                }else{
                    excludeList.push({pattern: element, index: i})  
                }
            }else{
                if(include){
                    includeList.push({pattern: element, index: i})  
                }else{
                    excludeList.push({pattern: element, index: i})  
                }
            }
           
        }
        return {includeList: includeList, excludeList: excludeList}
    }

    //srcCodeList中 不在CodeList中的所有元素
    protected findExcludeCodeList(srcCodeList: number[], codeList: number[]){
        let tmpList = []
        let tmpMap = {}
        for (let index = 0; index < codeList.length; index++) {
            const code = codeList[index];
            let logicCode = Card.codeToLogicCode(code)
            tmpMap[logicCode] = true
        }
        for (let index = 0; index < srcCodeList.length; index++) {
            const code = srcCodeList[index];
            let logicCode = Card.codeToLogicCode(code)
            if(!tmpMap[logicCode]){
                tmpList.push(code)
            }
        }
        return tmpList
    }

    //srcPokerList 不在pokerList中的所有元素
    protected findExcludePokerList(srcPokerList: PokerTablePokerBase[], pokerList: PokerTablePokerBase[]){
        let tmpList = []
        let tmpMap = {}
        for (let index = 0; index < pokerList.length; index++) {
            const poker = pokerList[index];
            let logicCode = Card.codeToLogicCode(poker.code)
            tmpMap[logicCode] = true
        }
        for (let index = 0; index < srcPokerList.length; index++) {
            const poker = srcPokerList[index];
            let logicCode = Card.codeToLogicCode(poker.code)
            if(!tmpMap[logicCode]){
                tmpList.push(poker)
            }
        }
        return tmpList
    }

    protected findCommonComingHandCards(commonCards: number[], selectedCommonCards: number[]){
        let list = []
        let tmpMap = {}
        for (let index = 0; index < selectedCommonCards.length; index++) {
            let code = selectedCommonCards[index];
            code = Card.codeToLogicCode(code)
            tmpMap[code] = true
        }
        let isStarted = false
        for (let index = 0; index < commonCards.length; index++) {
            const code = commonCards[index];
            let logicCode = Card.codeToLogicCode(code)
            if(tmpMap[logicCode]){
                isStarted = true
            }else if(isStarted){
                list.push(code)
            }
        }
        return list
    }

    protected filterCodeListBySrcId(codeList: number[], srcIds: number[]){
        let includeList = []
        let excludeList = []
        let tmpMap = {}
        for (let index = 0; index < srcIds.length; index++) {
            const srcId = srcIds[index];
            tmpMap[srcId] = true
        }
        for (let index = 0; index < codeList.length; index++) {
            const code = codeList[index];
            let srcId = Card.codeToSrcId(code)
            if(tmpMap[srcId]){
                includeList.push(code)
            }else{
                excludeList.push(code)
            }
        }
        return {includeList: includeList, excludeList: excludeList}
    }

    protected updateSeatInfo(data: Q2Game.ISeatInfo, seatInfo?: Q2SeatInfo){
        seatInfo = seatInfo || this.getSeatInfoByPlayerId(data.playerId) as Q2SeatInfo
        seatInfo.remotePos = data.seatId
        seatInfo.coinBalance = data.coinBalance
        seatInfo.playerId && UserDataManager.setUserGameTableCurrency(seatInfo.playerId, seatInfo.coinBalance)
        seatInfo.scoreBalance = data.scoreBalance
        seatInfo.cards = data.cards
        seatInfo.completeInfo = data.completeInfo
        seatInfo.finishedList = data.finishedList
        seatInfo.raisableList = data.raisableList
        seatInfo.storableList = data.storableList
        seatInfo.attachableList = data.attachableList
        seatInfo.canShowQ2 = data.canShowQ2
        seatInfo.showQ2 = data.showQ2
        seatInfo.isPlaying = data.isPlaying
        seatInfo.originalCardsMap = {}
        for (let i = 0; i < seatInfo.finishedList.length; i++) {
            const pattern = seatInfo.finishedList[i];
            for (let j = 0; j < pattern.origCards.length; j++) {
                const code = pattern.origCards[j];
                let logicCode = Card.codeToLogicCode(code)
                seatInfo.originalCardsMap[logicCode] = logicCode
            }
        }
    }

    protected initTableData(protoData: Q2Game.IGameInfo){
        let self = this
        let roomInfo = new Q2RoomInfo()   
        roomInfo.roomId = protoData.roomId     
        roomInfo.ruleTable = self.getRemoteRule()
        roomInfo.maxPlayerCount = protoData.maxPlayerCnt
        roomInfo.playerCount = protoData.seatList.length     
        roomInfo.state = protoData.state
        roomInfo.stateExpiredTime = protoData.stateExpiredTime
        roomInfo.stateDuration = protoData.stateDuration
        roomInfo.currentSeat = protoData.currentSeat
        roomInfo.timeOffset = protoData.time - Utility.nowTimestamp()
        roomInfo.isRoundStarted = protoData.state != 0
        roomInfo.pokerHeapCount = protoData.cardPoolLen
        roomInfo.commonCards = protoData.commonCards
        roomInfo.firstCommonCard = protoData.firstCommonCard
        Q2TablePoker.setFirstCardCode(roomInfo.firstCommonCard)
        roomInfo.firstSeatId = protoData.firstSeatId
        roomInfo.opDir = protoData.opDir    //操作方向 1：顺时针操作顺序1->4 2：逆时针 操作顺序4->1

        self.view.setSeatCount(roomInfo.maxPlayerCount)
        roomInfo.roundCount = roomInfo.ruleTable.roundCount
        roomInfo.isGoldTable = ModelData.instance.tableCommonData.tableType == 1
        let seatInfoList = []
        roomInfo.seatInfoList = seatInfoList
        for (let index = 1; index <= protoData.maxPlayerCnt; index++) {
            let element: Q2Game.ISeatInfo = {
                seatId: index,
                playerId: 0,
                coinBalance: 0,
                cards: [],
                userJson: '',
                scoreBalance: 0,
                canShowQ2: false,
                showQ2: false,
                isPlaying: false,
                completeInfo: null,
                finishedList: [],
                raisableList: [],
                storableList: [],
                attachableList: [],
            }
            for (let i = 0; i < protoData.seatList.length; i++) {
                const tmp = protoData.seatList[i];
                if(tmp.seatId == index){
                    element = tmp
                    UserDataManager.setUserJsonData(tmp.userJson)
                    break
                }
            }
            let seatInfo = self.genSeatInfo(element.playerId)
            self.updateSeatInfo(element, seatInfo)

            if (self.isMySelf(seatInfo.playerId)) {
                roomInfo.mySeatInfo = seatInfo
            }
            seatInfoList.push(seatInfo)
        }

        for (let i = 0; i < seatInfoList.length; i++) {
            const seatInfo = seatInfoList[i];
            seatInfo.localPos = self.getLocalPosFromRemotePos(seatInfo.remotePos, roomInfo.mySeatInfo.remotePos, roomInfo.maxPlayerCount)
        }

        self.setIsGoldTable(ModelData.instance.tableCommonData.tableType == 1)
        self.setIsMatchTable(ModelData.instance.tableCommonData.tableType == 2)        
        self.setRoomInfo(roomInfo)
        self.calcHintList()
    }

    protected onNetMsg_GameSettle(protoData: Q2Game.IGameSettle) {
        let self = this
        for (let index = 0; index < const_moduleNameList.length; index++) {
            const moduleName = const_moduleNameList[index];
            if(ModuleManager.instance.moduleHasActive(moduleName)){
                ModuleManager.instance.destroyModule(moduleName)
            }
        }
        ModuleManager.instance.hideModule('DialogLeave')
        self.cleanDesk()
        // self.closeServerConnect()
        
        let roomInfo = self.getRoomInfo<Q2RoomInfo>()  
        roomInfo.state = 6 
        let seatInfoList = roomInfo.seatInfoList
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        let selfIsPlaying = mySeatInfo.isPlaying
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as Q2SeatInfo            
            seatInfo.isPlaying = false
            seatInfo.cards = []
            seatInfo.scoreBalance = 0
            seatInfo.showQ2 = false
            seatInfo.canShowQ2 = false
            seatInfo.completeInfo = null
            seatInfo.finishedList = []
            seatInfo.raisableList = []
            seatInfo.storableList = []
            seatInfo.attachableList = []
            if(seatInfo.playerId){
                self.view.showSeatClock(seatInfo.localPos, false)
            }
        }
        
        if(!selfIsPlaying){
            self.view.showMatchPanel(true, 2)
            return
        }
        let seatPosMap = {}
        for (let index = 0; index < seatInfoList.length; index++) {
            const element = seatInfoList[index] as Q2SeatInfo
            element.isPlaying = false
            seatPosMap[element.remotePos] = element.localPos
        }
        let intentData: any = {
            settleData: protoData,
            seatPosMap: seatPosMap,
            //删除isMangoTable的判断  modif by dred 
            // isMango: ModelData.instance.tableCommonData.isMangoTable,
            backBtnCallback: function(){
                // self.onLeaveRoomSuccess()
                self.model.send_leave_request()
            },
            continueBtnCallback: function(){
                // let goldId = ModelData.instance.tableCommonData.goldFildId;
                // if (joinUtil.checkLeave(-888,goldId,self)) {
                    
                //     ModuleManager.instance.hideModule("Q2TableResultModule");
                    
                // }else{
                //     SceneManager.loadingTableModule(null,()=>{
                //         HallServer.instance.start_enter_gold_matching(goldId);
                //     });
                // }  
                for (let index = 0; index < seatInfoList.length; index++) {
                    const seatInfo = seatInfoList[index] as Q2SeatInfo                                
                    if(seatInfo.playerId){
                        self.view.showSeatScore(seatInfo.localPos, true, seatInfo.scoreBalance)
                    }
                }
                ModuleManager.instance.hideModule("Q2TableResultModule"); 
                self.send_ack()
                if(roomInfo.state == 6){
                    roomInfo.state = 0
                    let inCount = 0
                    for (let index = 0; index < seatInfoList.length; index++) {
                        const seatInfo = seatInfoList[index];
                        if(seatInfo.playerId){
                            inCount++
                        }
                    }
                    if(inCount < roomInfo.ruleTable.pub_MinPlayerNum){
                        self.view.showMatchPanel(true, 1)
                    }else{
                        self.view.showMatchPanel(true, 4)
                    }                    
                }
                if(self.isAutoLeaveOnEnd()){
                    self.setAutoLeaveOnEnd(false)
                    self.model.send_leave_request()
                    return
                }
            },
        }

        let showResultPanel = function(){
            for (let index = 0; index < protoData.seatList.length; index++) {
                const element = protoData.seatList[index];   
                let seatInfo = self.getSeatInfoByPlayerId(element.playerId) as Q2SeatInfo
                if(seatInfo){
                    seatInfo.coinBalance = element.coinBalance
                    seatInfo.playerId && UserDataManager.setUserGameTableCurrency(seatInfo.playerId, seatInfo.coinBalance)
                }             
                if(element.seatId == mySeatInfo.remotePos){
                    if(element.balance >= 0){
                        self.m_table_sound.playWinEffectSound()
                    }else{
                        self.m_table_sound.playLoseEffectSound()
                    }
                    break
                }
            }
            self.eventDispatch("Game_Table_Settlement", self.getSeatNodeById(mySeatInfo.playerId))
            ModuleManager.instance.showModule(Q2TableResultModule, intentData)
        }

        if(!protoData.completeSeatId){
            self.m_table_sound.fadeOutBgm()
            self.m_need_fadein_bgm = true
            self.view.playLiuJuAnim(function(){
                showResultPanel()
            })
        }else{
            showResultPanel()
        }
        
    }

    protected onNetMsg_TimeoutNotify(protoData: Q2Game.ITimeoutNotify) {
        let self = this
        if(protoData.event == 888){
            this.m_ack_id = protoData.ackId
            return
        }
        self.m_table_sound.stopClockTickEffectSound()
        let roomInfo = self.getRoomInfo<Q2RoomInfo>()
        roomInfo.state = protoData.event
        if(roomInfo.state == 0){            
            self.view.showMatchPanel(true, protoData.timeout != 0? 3: 0, protoData.timeout)
            self.cleanDesk(true)
            return
        }
        let mySeatInfo = roomInfo.mySeatInfo
        let lastCurrentSeat = roomInfo.currentSeat
        if(!protoData.seatId){
            return
        }
        roomInfo.currentSeat = protoData.seatId
        self.onSeatTurn(roomInfo.currentSeat, protoData.timeout, protoData.totalTimeout)
        if(lastCurrentSeat != mySeatInfo.remotePos && roomInfo.currentSeat == mySeatInfo.remotePos){
            self.m_table_sound.playMyTurnEffectSound()
            

            let needShowLast = false
            for (let index = 0; index < const_moduleNameList.length; index++) {
                const moduleName = const_moduleNameList[index];
                console.log(moduleName, ModuleManager.instance.moduleHasActive(moduleName))
                if(ModuleManager.instance.moduleHasActive(moduleName)){
                    needShowLast = true
                    ModuleManager.instance.destroyModule(moduleName)
                }
            }
            if(!needShowLast){
                self.m_last_show_module_fun = null
            }
            self.m_need_show_module_fun = self.m_last_show_module_fun        
        }
        if(lastCurrentSeat == mySeatInfo.remotePos && roomInfo.currentSeat != mySeatInfo.remotePos){
            if(self.m_need_show_module_fun){
                let fun = self.m_need_show_module_fun
                self.m_need_show_module_fun = null
                self.m_last_show_module_fun = null
                fun && fun()
            }
        }
        self.refreshBtns()
        self.onOperate()
    }

    protected onSeatTurn(currentSeat: number, leftSecs: number, totalSecs: number){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        let seatInfoList = roomInfo.seatInfoList

        let hasPlayTickSound = false
        let hasShowTips = false
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as Q2SeatInfo
            self.view.showSeatSelected(seatInfo.localPos, false)
            self.view.showSeatClock(seatInfo.localPos, seatInfo.remotePos == currentSeat, leftSecs, seatInfo == mySeatInfo, null, function(leftSecs){
                if(seatInfo == mySeatInfo && !hasPlayTickSound && leftSecs <= 5){
                    hasPlayTickSound = true
                    self.m_table_sound.playClockTickEffectSound()
                }   
                if(currentSeat == mySeatInfo.remotePos){
                    if(self.m_operatType == OperatType.ShowQ2){
                        if(leftSecs <= 10){
                            !hasShowTips && self.view.showBtnTips(!!mySeatInfo.canShowQ2, LanguageManager.t('q2_table_tips_default_morecard', true), self.getNodeWorldPos(self.view.buttonShowQ2.node))
                            hasShowTips = true
                        }
                    }
                    if(self.m_operatType == OperatType.QuickHu){
                        if(leftSecs <= 10){
                            !hasShowTips && self.view.showBtnTips(true, roomInfo.state == 4? LanguageManager.t('q2_table_tips_default_morecard', true): LanguageManager.t('q2_table_tips_default_discard', true), self.getNodeWorldPos(self.view.buttonQuickHu.node))
                            hasShowTips = true
                        }
                    }
                }     
                     
            }, totalSecs)
        }
        let currentSeatInfo = self.getSeatInfoByRemotePos(currentSeat)
        self.view.showSeatSelected(currentSeatInfo.localPos, true)
    }

    protected onNetMsg_CardReocrderNotify(protoData: Q2Game.ICardReocrderNotify){
        let dataList = []
        let dataMap = {}
        for (let index = 0; index < protoData.cards.length; index++) {
            const code = protoData.cards[index];
            let card = Card.makeCardByCode(code)
            let d = dataMap[card.index] || {point: card.index, count: 0, colorCountList: [0, 0, 0, 0]}
            d.count++
            d.colorCountList[card.color - 1]++
            dataMap[card.index] = d
        }
        for (const key in dataMap) {
            if (dataMap.hasOwnProperty(key)) {
                const element = dataMap[key];
                dataList.push(element)
            }
        }
        this.view.refreshPokerRecorder({dataList: dataList})        
        this.view.showPokerRecorder(true, !this.m_has_show_recorder)
        this.m_has_show_recorder = true
    }

    @bindButtonClickEvent('showQ2Btn')
    protected on_click_show_q2_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        self.view.showShowQ2Btn(true, true)
        this.view.playBtnsFadeAnim(false, function(){
            self.view.showShowQ2Btn(false)
            self.view.showCancelBtn(false)            
        })
        this.model.send_show_q2_req(true)    
        this.view.showBtnTips(false)    
    }

    @bindButtonClickEvent('moreCardBtn')
    protected on_click_more_card_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        self.view.showMoreCardBtn(true, true)
        this.view.playBtnsFadeAnim(false, function(){
            self.view.showRaiseBtn(false)
            self.view.showMoreCardBtn(false)            
        })
        this.model.send_more_card_req()        
    }

    @bindButtonClickEvent('raiseBtn')
    protected on_click_raise_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        this.m_operatType = OperatType.Raise
        
        this.view.showRaiseBtn(false)
        this.view.showMoreCardBtn(false)
        this.view.showConfirmBtn(true)
        this.view.showCancelBtn(true)
        //提示升牌
        self.view.mySeatCards.resetPokers()
        self.onOperate()
        self.view.showHintBtn(true)
        self.checkActionBtnState()
    }

    @bindButtonClickEvent('storageBtn')
    protected on_click_storage_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        this.m_operatType = OperatType.Storage
        self.view.mySeatCards.resetPokers()
        this.view.showStorageBtn(false)
        this.view.showAttachBtn(false)
        this.view.showDiscardBtn(false)

        this.view.showConfirmBtn(true)
        this.view.showCancelBtn(true)
        //提示下牌
        self.view.mySeatCards.resetPokers()
        self.onOperate()
        self.view.showHintBtn(true)
        self.checkActionBtnState()
    }

    @bindButtonClickEvent('attachBtn')
    protected on_click_attach_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        this.m_operatType = OperatType.Attach
        self.view.mySeatCards.resetPokers()
        this.view.showStorageBtn(false)
        this.view.showAttachBtn(false)
        this.view.showDiscardBtn(false)
        
        this.view.showConfirmBtn(true)
        this.view.showCancelBtn(true)
        //提示存牌
        self.view.mySeatCards.resetPokers()
        self.onOperate()
        self.view.showHintBtn(true)
        self.checkActionBtnState()
    }

    @bindButtonClickEvent('quickHuBtn')
    protected on_click_quick_hu_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        self.model.send_complete_req(true)
        this.view.showBtnTips(false)    
    }

    @bindButtonClickEvent('confirmBtn')
    protected on_click_confirm_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        
        this.view.showStorageBtn(false)
        this.view.showAttachBtn(false)
        this.view.showDiscardBtn(false)
        this.view.showRaiseBtn(false)

        this.view.showConfirmBtn(true)
        this.view.showCancelBtn(true)
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo

        let deskCardsData
        let selectedCardsData     
        let codeList = []  
        let handCodeList = []
        let areaCodeList = []
        let commonCodeList = [] 
        switch (this.m_operatType) {
            case OperatType.Raise:                
                deskCardsData = self.view.deskCards.getSelectedPokers()                
                for (let index = 0; index < deskCardsData.real_selected_codeList.length; index++) {
                    let code = deskCardsData.real_selected_codeList[index];
                    code = Card.fullCodeToCode(code)
                    codeList.push(code)
                    commonCodeList.push(code)
                }
                let inCodeList = self.findCommonComingHandCards(roomInfo.commonCards, deskCardsData.real_selected_codeList)
                selectedCardsData = self.view.mySeatCards.getSelectedPokers()
                for (let index = 0; index < selectedCardsData.real_selected_codeList.length; index++) {
                    let code = selectedCardsData.real_selected_codeList[index];
                    code = Card.fullCodeToCode(code)
                    codeList.push(code)
                    handCodeList.push(code)
                }
                if(mySeatInfo.cards.length + inCodeList.length == handCodeList.length){
                    ModuleManager.instance.toastKey('q2_table_tips_cannot_raise')
                    return
                }
                if(!self.canRaise(commonCodeList, handCodeList)){
                    ModuleManager.instance.toastKey('q2_table_tips_cannot_raise')
                    return
                }
                self.model.send_raise_req(handCodeList, commonCodeList)
                break;        
            case OperatType.Storage:
                selectedCardsData = self.view.mySeatCards.getSelectedPokers()
                for (let index = 0; index < selectedCardsData.real_selected_codeList.length; index++) {
                    let code = selectedCardsData.real_selected_codeList[index];
                    code = Card.fullCodeToCode(code)
                    codeList.push(code)
                    handCodeList.push(code)
                }
                if(mySeatInfo.cards.length == handCodeList.length){
                    ModuleManager.instance.toastKey('q2_table_tips_cannot_storage')
                    return
                }
                if(!self.canStorage(handCodeList)){
                    ModuleManager.instance.toastKey('q2_table_tips_cannot_storage')
                    return
                }
                self.model.send_storage_req(codeList)
                break;
            case OperatType.Attach:
                if(mySeatInfo.cards.length == 1){
                    ModuleManager.instance.toastKey('q2_table_tips_cannot_attach')
                    return
                }
                selectedCardsData = self.view.mySeatCards.getSelectedPokers()
                for (let index = 0; index < selectedCardsData.real_selected_codeList.length; index++) {
                    let code = selectedCardsData.real_selected_codeList[index];
                    code = Card.fullCodeToCode(code)
                    codeList.push(code)
                    handCodeList.push(code)
                }
                let targetSeatInfo = self.getSeatInfoByLocalPos(self.m_select_area) as Q2SeatInfo
                let pattern = targetSeatInfo.finishedList[self.m_select_pattern_index]
                areaCodeList = pattern.cards.concat()
                if(handCodeList.length != 1 || !self.canAttach(areaCodeList, handCodeList[0])){
                    ModuleManager.instance.toastKey('q2_table_tips_cannot_attach')
                    return
                }
                self.model.send_attach_req(targetSeatInfo.remotePos, handCodeList[0], areaCodeList)
                break;
            case OperatType.ShowQ2:
                
                break;
            case OperatType.QuickHu:
    
                break;
        }
    }

    @bindButtonClickEvent('cancelBtn')
    protected on_click_cancel_btn(node: cc.Node){
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        if(this.m_operatType == OperatType.QuickHu){
            this.model.send_complete_req(false)
            mySeatInfo.completeInfo = null
            this.refreshBtns()
        }else if(this.m_operatType == OperatType.ShowQ2){            
            this.model.send_show_q2_req(false)
            mySeatInfo.canShowQ2 = false
            this.refreshBtns()
        }else{
            this.view.showBtnTips(false)
            this.selectCards(null, null)
            this.refreshBtns()  
        }        
    }

    @bindButtonClickEvent('hintBtn')
    protected on_click_hint_btn(node: cc.Node){
        this.hintCards()
    }

    @bindButtonClickEvent('discardBtn')
    protected on_click_discard_btn(node: cc.Node){
        let self = this
        this.view.playBtnClickAnim(node)
        let selectedData = self.view.mySeatCards.getSelectedPokers()
        if(selectedData.real_selected_codeList.length > 1){
            self.view.showBtnTips(true, LanguageManager.t('q2_table_tips_select_one', true), this.view.buttonDiscard.node.parent.convertToWorldSpaceAR(this.view.buttonDiscard.node.position))
            return
        }else if(selectedData.real_selected_codeList.length < 1){            
            self.view.showBtnTips(true, LanguageManager.t('q2_table_tips_select_one', true), this.view.buttonDiscard.node.parent.convertToWorldSpaceAR(this.view.buttonDiscard.node.position))
            return
        }
        self.view.showDiscardBtn(true, true)
        this.view.playBtnsFadeAnim(false, function(){
            self.view.showStorageBtn(false)
            self.view.showAttachBtn(false)  
            self.view.showDiscardBtn(false)          
        })
        self.model.send_discard_req(Card.fullCodeToCode(selectedData.real_selected_codeList[0]))
    }

    @bindButtonClickEvent('sortCardsBtn')
    protected on_click_sort_cards_btn(node: cc.Node){
        this.m_table_sound.playClickSortBtnEffectSound()
        if(this.view.mySeatCards.isPlayingMoveAnim){
            return
        }
        this.m_last_sort_type++
        if(this.m_last_sort_type > 2){
            this.m_last_sort_type = 1
        }
        this.view.mySeatCards.sortPokers(this.m_last_sort_type, true)        
    }    

    @bindButtonClickEvent('matchLeaveBtn')
    protected on_click_match_leave_btn(node: cc.Node){
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        if(roomInfo.state == 0 || roomInfo.state == 6){
            this.model.send_leave_request()
            return
        }
    }

    protected on_click_menu_leave_btn(node: cc.Node){
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        if(roomInfo.state == 0 || roomInfo.state == 6){
            this.model.send_leave_request()
            return
        }
        if(!mySeatInfo.isPlaying){
            this.model.send_leave_request()
            return
        }

        ModuleManager.instance.showModule(DialogLeave)
    }

    @bindButtonClickEvent('MoreBtn')
    protected on_click_more_btn(node: cc.Node){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        ModuleManager.instance.showModule(GameMorePanel, {showModuleCallback: function(moduleClass){
            self.m_last_show_module_fun = function(){
                ModuleManager.instance.showModule(moduleClass)
            }
            if(roomInfo.currentSeat == roomInfo.mySeatInfo.remotePos){
                self.m_need_show_module_fun = self.m_last_show_module_fun
            }            
        }, onFinishShowModuleCallback: function(module){            
            if(roomInfo.currentSeat == roomInfo.mySeatInfo.remotePos){
                self.doScheduleOnce(function(){
                    ModuleManager.instance.destroyModule(module.moduleName)
                }, 0.4)
            }
        }})

    }

    protected on_click_area_pattern(areaCards: Q2SeatAreaCards, patternIndex: number){
        let self = this
        let areaCardsList = this.view.seatAreaCardsList
        let lastSelectArea = self.m_select_area
        let lastSelectIndex = self.m_select_pattern_index
        if(self.m_operatType != OperatType.Attach){
            return
        }
        for (let index = 0; index < areaCardsList.length; index++) {
            const tmpAreaCards = areaCardsList[index];
            if(areaCards == tmpAreaCards){
                this.m_select_area = index
                this.m_select_pattern_index = patternIndex
                let lastArea = self.view.seatAreaCardsList[lastSelectArea]
                if(lastArea){
                    lastArea.setPatternState(lastSelectIndex, SelectState.Normal)
                    lastArea.refreshPatternSelectState()
                }
                
                let area = self.view.seatAreaCardsList[index]
                if(area){
                    area.setPatternState(patternIndex, SelectState.Selected)
                    area.refreshPatternSelectState()
                }                
                return
            }
        }
    }

    protected refreshBtns(){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo

        self.view.showShowQ2Btn(false)
        self.view.showQuickHuBtn(false)
        self.view.showConfirmBtn(false)
        self.view.showCancelBtn(false)
        self.view.showHintBtn(false)
        self.view.showMoreCardBtn(false)
        self.view.showDiscardBtn(false)
        self.view.showRaiseBtn(false)
        self.view.showStorageBtn(false)
        self.view.showAttachBtn(false)
        self.m_operatType = OperatType.None
        self.view.showBtnTips(false)
        if(roomInfo.currentSeat == mySeatInfo.remotePos){
            if(roomInfo.state == 4){    //第一阶段
                if(mySeatInfo.canShowQ2){
                    self.m_operatType = OperatType.ShowQ2
                    self.view.showCancelBtn(true)
                    self.view.showShowQ2Btn(true)
                    return
                }
                if(mySeatInfo.completeInfo && mySeatInfo.completeInfo.canComplete){
                    self.m_operatType = OperatType.QuickHu
                    self.view.showCancelBtn(true)
                    self.view.showQuickHuBtn(true)
                    this.view.playBtnsFadeAnim(true)
                    return
                }         
                if(mySeatInfo.raisableList && mySeatInfo.raisableList.length > 0){
                    self.view.showRaiseBtn(true)
                }else{
                    self.view.showRaiseBtn(true, true, true)
                }
                
                self.view.showMoreCardBtn(true)
                this.view.playBtnsFadeAnim(true)
            }else if(roomInfo.state == 5){  //第二阶段
                if(mySeatInfo.completeInfo && mySeatInfo.completeInfo.canComplete){
                    self.m_operatType = OperatType.QuickHu
                    self.view.showCancelBtn(true)
                    self.view.showQuickHuBtn(true)
                    this.view.playBtnsFadeAnim(true)
                    return
                }
                self.m_operatType = OperatType.Discard
                if(mySeatInfo.storableList && mySeatInfo.storableList.length > 0){
                    self.view.showStorageBtn(true)
                }else{
                    self.view.showStorageBtn(true, true, true)
                }
                if(mySeatInfo.attachableList && mySeatInfo.attachableList.length > 0){
                    self.view.showAttachBtn(true)                    
                }else{
                    self.view.showAttachBtn(true, true, true)
                }
                self.view.showDiscardBtn(true)
                this.view.playBtnsFadeAnim(true)
            }else{
                
            }
        }
        
    }

    protected onOperate(){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        if(roomInfo.currentSeat == mySeatInfo.remotePos){
            self.m_hint_func = null            
            self.view.mySeatCards.resetPokers()
            if(mySeatInfo.completeInfo && mySeatInfo.completeInfo.canComplete){
                let opList = mySeatInfo.completeInfo.opList
                let raiseCodeList = []
                let storageCodeList = []
                let attachCodeList = []
                let discardCode = 0
                for (let index = 0; index < opList.length; index++) {
                    const op = opList[index];
                    if(op.cards.length != op.origCards.length){
                        let tmpAttachCodeList = self.findExcludeCodeList(op.cards, op.origCards)   
                        attachCodeList = attachCodeList.concat(tmpAttachCodeList)
                    }else{
                        if(op.origOp == 1){ //升牌
                            raiseCodeList = raiseCodeList.concat(op.cards)
                        }else if(op.origOp == 2){
                            storageCodeList = storageCodeList.concat(op.cards)
                        }else if(op.origOp == 0){
                            discardCode = op.cards[0]
                        }
                    }                     
                }
                self.view.showQuickHuCards(true, raiseCodeList, storageCodeList, attachCodeList, discardCode)
                return
            }
            if(roomInfo.state == 4){                
                if(self.m_operatType == OperatType.Raise && mySeatInfo.raisableList && mySeatInfo.raisableList.length > 0){
                    let tmpData = self.getSelectCodesAndCanSelectCodes()
                    self.selectCards(tmpData.selectCodeList, tmpData.canSelectCodeList)
                    return
                }

            }else if(roomInfo.state == 5){
                if(self.m_operatType == OperatType.Storage && mySeatInfo.storableList && mySeatInfo.storableList.length > 0){
                    let tmpData = self.getSelectCodesAndCanSelectCodes()
                    self.selectCards(tmpData.selectCodeList, tmpData.canSelectCodeList)
                    return
                }
                if(self.m_operatType == OperatType.Attach && mySeatInfo.attachableList && mySeatInfo.attachableList.length > 0){
                    let tmpData = self.getSelectCodesAndCanSelectCodes()
                    self.selectCards(tmpData.selectCodeList, tmpData.canSelectCodeList)
                    return
                }
            }
        }
        
    }

    protected hintCards(){
        let self = this
        if(!self.m_hint_func){
            let index = 0
            let hintList = null
            if(self.m_operatType == OperatType.Raise){
                hintList = self.m_raise_hint_list
            }else if(self.m_operatType == OperatType.Storage){
                hintList = self.m_storage_hint_list
            }else if(self.m_operatType == OperatType.Attach){
                hintList = self.m_attach_hint_list
            }
            self.m_hint_func = function(){
                if(hintList && hintList.length > 0){
                    if(index >= hintList.length){
                        index = 0
                    }
                    return hintList[index++]
                }
                return null
            }
        }
        let data = self.m_hint_func()
        data && self.selectCards(data.selectCodeList, data.canSelectCodeList)
        self.checkActionBtnState()
    }

    protected getSelectCodesAndCanSelectCodes(selectedHandCodes?: number[]){
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let mySeatInfo = roomInfo.mySeatInfo as Q2SeatInfo
        self.m_attach_hint_list = []
        self.m_hint_func = null
        if(self.m_operatType == OperatType.Raise && mySeatInfo.raisableList && mySeatInfo.raisableList.length > 0){
            let listList = []
            let canSelectCodeList = []
            for (let index = 0; index < mySeatInfo.raisableList.length; index++) {
                const pattern = mySeatInfo.raisableList[index];
                let tmpCodeList = []
                listList.push({selectCodeList: tmpCodeList, canSelectCodeList: canSelectCodeList})
                for (let i = 0; i < pattern.cards.length; i++) {
                    let code = pattern.cards[i]
                    tmpCodeList.push(code)                        
                    canSelectCodeList.push(code) 
                }
            }
            self.m_attach_hint_list = listList
            return listList[0]
        }
        if(self.m_operatType == OperatType.Storage && mySeatInfo.storableList && mySeatInfo.storableList.length > 0){
            let listList = []
            let canSelectCodeList = []
            for (let index = 0; index < mySeatInfo.storableList.length; index++) {
                const pattern = mySeatInfo.storableList[index];
                let tmpCodeList = []
                listList.push({selectCodeList: tmpCodeList, canSelectCodeList: canSelectCodeList})
                for (let i = 0; i < pattern.cards.length; i++) {
                    let code = pattern.cards[i]
                    tmpCodeList.push(code)                          
                    canSelectCodeList.push(code) 
                }
            }
            self.m_attach_hint_list = listList
            return listList[0]
        }
        if(self.m_operatType == OperatType.Attach && mySeatInfo.attachableList && mySeatInfo.attachableList.length > 0){
            let listList = []
            let tmpMap = {}
            let canSelectAttachCodeList = []
            let attachCode = null
            if(selectedHandCodes && selectedHandCodes.length == 1){
                attachCode = selectedHandCodes[0]
            }
            for (let index = 0; index < mySeatInfo.attachableList.length; index++) {
                const pattern = mySeatInfo.attachableList[index];  

                let tmpAttachCode = self.findExcludeCodeList(pattern.cards, pattern.origCards)[0]     
                canSelectAttachCodeList.push(tmpAttachCode)  

                tmpMap[tmpAttachCode] = tmpMap[tmpAttachCode] || []
                let tmpData: any = {}
                tmpData.attachCode = tmpAttachCode
                tmpData.cards = pattern.cards.concat()
                tmpMap[tmpAttachCode].push(tmpData)   
                if(!attachCode){
                    attachCode = tmpAttachCode
                }             
            }

            let listMap = {}
            for (const key in tmpMap) {
                if (tmpMap.hasOwnProperty(key)) {
                    const list = tmpMap[key];
                    for (let i = 0; i < list.length; i++) {
                        const element = list[i];
                        let data: any = {}
                        data.attachCode = element.attachCode
                        data.canSelectCodeList = canSelectAttachCodeList
                        data.selectCodeList = element.cards.concat()
                        for (let j = 0; j < list.length; j++) {
                            const tmp = list[j];
                            data.canSelectCodeList = data.canSelectCodeList.concat(tmp.cards)
                        }
                        listMap[key] = listMap[key] || []
                        listMap[key].push(data)
                    }
                }
            }


            for (const key in listMap) {
                if (listMap.hasOwnProperty(key)) {
                    const list = listMap[key];
                    listList.concat(list)
                }
            }

            self.m_attach_hint_list = listList            
            return listMap[attachCode][0]
        }
    }

    protected selectCards(selectCodeList: number[], canSelectCodeList: number[]){
        let self = this    
        if(!selectCodeList || !canSelectCodeList){
            self.view.mySeatCards.resetPokers()
            self.view.deskCards.resetPokers()
            self.unSelectAllAreaPattern()
            return
        }
        self.view.mySeatCards.enablePokers(selectCodeList.concat(canSelectCodeList))        
        self.view.mySeatCards.refreshPokerDisableState()
        self.view.mySeatCards.selectPokers(selectCodeList, null)
        self.view.mySeatCards.refreshPokerSelectState(false)

        self.view.deskCards.enablePokers(selectCodeList.concat(canSelectCodeList))
        self.view.deskCards.refreshPokerDisableState()
        self.view.deskCards.selectPokers(selectCodeList, null)
        self.view.deskCards.refreshPokerSelectState(false)    
        
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        let seatInfoList = roomInfo.seatInfoList
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as Q2SeatInfo
            if(seatInfo.playerId){
                let tmpPatterns = self.findPatternsInList(seatInfo.finishedList, selectCodeList)
                let tmpPatterns1 = self.findPatternsInList(seatInfo.finishedList, canSelectCodeList)
                let disableIndexList = []
                for (let i = 0; i < tmpPatterns1.excludeList.length; i++) {
                    const tmpData = tmpPatterns1.excludeList[i];
                    disableIndexList.push(tmpData.index)
                }
                let selectIndexList = []
                for (let i = 0; i < tmpPatterns.includeList.length; i++) {
                    const tmpData = tmpPatterns.includeList[i];
                    selectIndexList.push(tmpData.index)
                }
                let areaCards = this.view.seatAreaCardsList[seatInfo.localPos]
                areaCards.setState(disableIndexList, selectIndexList, null)
                areaCards.refreshPatternSelectState()
                if(selectIndexList.length > 0){
                    self.m_select_area = seatInfo.localPos
                    self.m_select_pattern_index = selectIndexList[0]
                }
            }
        }
    }

    protected setAllNormalState(){
        let self = this
        self.view.mySeatCards.enabledAllPokers()
        self.view.mySeatCards.refreshPokerDisableState()
        self.view.deskCards.enabledAllPokers()
        self.view.deskCards.refreshPokerDisableState()         
        self.unSelectAllAreaPattern()
    }

    protected unSelectAllAreaPattern(){
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let seatInfoList = roomInfo.seatInfoList
        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index] as Q2SeatInfo
            if(seatInfo.playerId){
                let areaCards = this.view.seatAreaCardsList[seatInfo.localPos]
                areaCards.setState([], null, null)
                areaCards.refreshPatternSelectState()
            }
        }       
    }


    protected playHuPaiAnim(seatInfo: Q2SeatInfo, scoreDataList: Q2Game.IScore[], onFinish: Function, fromCompleteProcess: boolean){
        let self = this
        let huMap = {}
        let seatChangeDateMap = {}
        for (let index = 0; index < scoreDataList.length; index++) {
            const element = scoreDataList[index];
            huMap[element.seatId] = huMap[element.seatId] || {}
            huMap[element.seatId][element.scoreReason] = true

            seatChangeDateMap[element.seatId] = seatChangeDateMap[element.seatId] || {score: 0}
            seatChangeDateMap[element.seatId].score += element.score
            seatChangeDateMap[element.seatId].scoreBalance = element.scoreBalance
        }
        for (let index = 0; index < scoreDataList.length; index++) {
            const element = scoreDataList[index];
            if(element.scoreReason >= 20){
                continue
            }
  
            if(element.seatId == seatInfo.remotePos){      
                if(element.scoreReason == 1 || element.scoreReason == 3 || element.scoreReason == 4 || element.scoreReason == 14 || element.scoreReason == 6){
                    let changeData = seatChangeDateMap[seatInfo.remotePos]
                    seatInfo.scoreBalance = changeData.scoreBalance
                    self.view.showSeatScore(seatInfo.localPos, true, changeData.scoreBalance)
                    self.view.playSeatPiaoFenAnim(seatInfo.localPos, changeData.score, function(){
                        
                    }, fromCompleteProcess? 1: 0)
                }          
                if(huMap[element.seatId][5]){
                    if(element.scoreReason == 5){
                        continue
                    }
                    if(element.scoreReason == 6){
                        self.view.playCommonAnim(EffectType.PaiXing_LianJiHu_QingYiSe, onFinish)
                        self.playScoreChangeEffectSound(EffectType.LianJiHu_QingYiSe)
                        self.playScoreChangeSound(seatInfo, EffectType.LianJiHu_QingYiSe)
                        return
                    }else if(element.scoreReason == 1 || element.scoreReason == 3 || element.scoreReason == 4 || element.scoreReason == 14){
                        self.view.playCommonAnim(EffectType.PaiXing_LianJiHu, onFinish)
                        self.playScoreChangeEffectSound(EffectType.PaiXing_LianJiHu)
                        self.playScoreChangeSound(seatInfo, EffectType.PaiXing_LianJiHu)
                        return
                    }else{
                        continue
                    }
                }else{
                    if(element.scoreReason == 1){//胡牌
                        self.view.playCommonAnim(EffectType.PaiXing_HuPai, onFinish)
                        self.playScoreChangeEffectSound(element.scoreReason)
                        self.playScoreChangeSound(seatInfo, element.scoreReason)
                        return
                    }else if(element.scoreReason == 3 || element.scoreReason == 4 || element.scoreReason == 14){//dummy胡牌
                        self.view.playCommonAnim(EffectType.PaiXing_HuPai_Dummy, onFinish)
                        self.playScoreChangeEffectSound(element.scoreReason)
                        self.playScoreChangeSound(seatInfo, element.scoreReason)
                        return
                    }else if(element.scoreReason == 6){//清一色                
                        self.view.playCommonAnim(EffectType.PaiXing_QingYiSe, onFinish)
                        self.playScoreChangeEffectSound(element.scoreReason)
                        self.playScoreChangeSound(seatInfo, element.scoreReason)
                        return
                    }else{
                        continue
                    }
                    
                }                
                
            }            
        }
        onFinish && onFinish()
    }


    protected playScoreChangeAnim(scoreDataList: Q2Game.IScore[], onFinish: Function, includeGuangTou?: boolean, includeFangPao?: boolean, withOutElephant?: boolean, fromCompleteProcess?: boolean){
        let self = this
        let huMap = {}
        let specialMap = {}
        let seatChangeDateMap = {}
        for (let index = 0; index < scoreDataList.length; index++) {
            const element = scoreDataList[index];
            let seatInfo = self.getSeatInfoByRemotePos(element.seatId) as Q2SeatInfo
            if(element.scoreReason == 3 || element.scoreReason == 4 || element.scoreReason == 14){
                specialMap[element.seatId]++
            }
            huMap[element.seatId] = huMap[element.seatId] || {}
            huMap[element.seatId][element.scoreReason] = true

            seatChangeDateMap[element.seatId] = seatChangeDateMap[element.seatId] || {score: 0}
            seatChangeDateMap[element.seatId].score += element.score
            seatChangeDateMap[element.seatId].scoreBalance = element.scoreBalance
        }

        let finishLianJiHuMap = {}
        let seatAnimListMap = {}
        for (let index = 0; index < scoreDataList.length; index++) {
            const element = scoreDataList[index];
            if(!withOutElephant && element.scoreReason >= 20){
                continue
            }
            if(withOutElephant && element.scoreReason < 20){
                continue
            }
            let tmpMap = huMap[element.seatId]
            let seatInfo = self.getSeatInfoByRemotePos(element.seatId) as Q2SeatInfo
            let tmpFun

            if(!withOutElephant && huMap[element.seatId][5]){
                if(element.scoreReason == 5){
                    continue
                }
                if(includeGuangTou && element.scoreReason == EffectType.GuangTou
                    || includeFangPao && element.scoreReason == EffectType.ZhaDan
                    || !includeGuangTou && !includeFangPao && element.scoreReason != EffectType.GuangTou && element.scoreReason != EffectType.ZhaDan){
                        if(!finishLianJiHuMap[element.seatId]){
                            let effectType = null                                    
                            tmpFun = function(cb){
                                let changeData = seatChangeDateMap[seatInfo.remotePos]
                                seatInfo.scoreBalance = changeData.scoreBalance
                                self.view.showSeatScore(seatInfo.localPos, true, changeData.scoreBalance)
                                self.view.playSeatPiaoFenAnim(seatInfo.localPos, changeData.score, function(){
                                    
                                }, fromCompleteProcess? 1: 0)
        
                                self.view.playAreaAnim(seatInfo.localPos, effectType, cb)
                                self.playScoreChangeEffectSound(effectType)
                                self.playScoreChangeSound(seatInfo, effectType)
                                
                            }
                            if(element.scoreReason == 6){
                                effectType = EffectType.LianJiHu_QingYiSe
                                seatAnimListMap[seatInfo.localPos] = seatAnimListMap[seatInfo.localPos] || [] 
                                seatAnimListMap[seatInfo.localPos].push(tmpFun) 
                                finishLianJiHuMap[element.seatId] = true  
                                continue
                            }else if(element.scoreReason == 1 || element.scoreReason == 3 || element.scoreReason == 4 || element.scoreReason == 14){    //其他类型的连击胡胡牌都是用连击胡特效
                                effectType = EffectType.LianJiHu
                                seatAnimListMap[seatInfo.localPos] = seatAnimListMap[seatInfo.localPos] || [] 
                                seatAnimListMap[seatInfo.localPos].push(tmpFun) 
                                finishLianJiHuMap[element.seatId] = true  
                                continue
                            }else if(element.scoreReason == 5){
                                continue
                            }                                                  
                        }
                }                  
            }

            tmpFun = function(cb){
                seatInfo.scoreBalance = element.scoreBalance
                self.view.showSeatScore(seatInfo.localPos, true, element.scoreBalance)
                
                if(withOutElephant && element.scoreReason >= 20){                    
                    self.view.playSeatPiaoFenAnim(seatInfo.localPos, element.score, cb, fromCompleteProcess? 1: 0)
                    return
                }
                self.view.playSeatPiaoFenAnim(seatInfo.localPos, element.score, function(){

                }, fromCompleteProcess? 1: 0)
                self.view.playAreaAnim(seatInfo.localPos, element.scoreReason, cb)
                self.playScoreChangeEffectSound(element.scoreReason)
                self.playScoreChangeSound(seatInfo, element.scoreReason)
            }
            if(includeGuangTou && element.scoreReason == EffectType.GuangTou
                || includeFangPao && element.scoreReason == EffectType.ZhaDan
                || !includeGuangTou && !includeFangPao && element.scoreReason != EffectType.GuangTou && element.scoreReason != EffectType.ZhaDan){
                seatAnimListMap[seatInfo.localPos] = seatAnimListMap[seatInfo.localPos] || [] 
                seatAnimListMap[seatInfo.localPos].push(tmpFun)    
            }     
        }
        let animList = []
        for (const key in seatAnimListMap) {
            if (seatAnimListMap.hasOwnProperty(key)) {
                const tmpAnimList = seatAnimListMap[key];
                if(tmpAnimList && tmpAnimList.length > 0){
                    animList.push(function(cb){
                        PromiseUtility.sequence(tmpAnimList).then(cb)
                    })
                }
            }
        }
        PromiseUtility.all(animList).then(function(){
            onFinish && onFinish()
        })
    }

    protected playScoreChangeEffectSound(type: EffectType){
        switch (type) {
            case EffectType.ShowQ2:
                this.m_table_sound.playShowQ2EffectSound()
                break;
            case EffectType.BeiFangQ2:
            case EffectType.BeiFangQ2_Common:
                this.m_table_sound.playPunishedQ2EffectSound()
                break;
            case EffectType.ZhaDan:
                this.m_table_sound.playBombEffectSound()
                break;
            case EffectType.DiuChengPai:
            case EffectType.DiuDummy:
            case EffectType.DiuTouPai:
                this.m_table_sound.playDiuFenEffectSound()
                break;            
            case EffectType.GuangTou:
                this.m_table_sound.playZeroEffectSound()
                break;     
            case EffectType.NaTouPai:
                this.m_table_sound.playHeadEffectSound()
                break;
            case EffectType.LianJiHu:
            case EffectType.LianJiHu_QingYiSe:
            case EffectType.QingYiSe:
            case EffectType.HuPai:
            case EffectType.HuPai_2:
            case EffectType.HuPai_Q:
            case EffectType.HuPai_Dummy:
                this.m_table_sound.playDrawEffectSound()
                break;                            
            default:
                break;
        }
    }

    protected playScoreChangeSound(seatInfo: Q2SeatInfo, type: EffectType){        
        let isMale = seatInfo.userInfo && seatInfo.userInfo.gender == 1
        switch (type) {
            case EffectType.ShowQ2:
                this.m_table_sound.playShowQ2Sound(isMale)
                break;
            case EffectType.BeiFangQ2:
            case EffectType.BeiFangQ2_Common:
                
                break;
            case EffectType.ZhaDan:
                
                break;
            case EffectType.NaTouPai:
                this.m_table_sound.playHeadSound(isMale)
                break;
            case EffectType.DiuChengPai:
            case EffectType.DiuDummy:
            case EffectType.DiuTouPai:
                break;            
            case EffectType.GuangTou:
                break;      
            case EffectType.LianJiHu:
                this.m_table_sound.playLianJiHuSound(isMale)
            case EffectType.LianJiHu_QingYiSe:
                this.m_table_sound.playLianJiHuSound(isMale, ()=>{
                    this.m_table_sound.playQingYiSeSound(isMale)
                })
                break;
            case EffectType.QingYiSe:
                this.m_table_sound.playQingYiSeSound(isMale)
                break;
            case EffectType.HuPai:
                this.m_table_sound.playHuPaiSound(isMale)
                break;
            case EffectType.HuPai_2:
            case EffectType.HuPai_Q:
                this.m_table_sound.playHuQ2Sound(isMale)
                break;
            case EffectType.HuPai_Dummy:
                this.m_table_sound.playHuDummySound(isMale)
                break;                            
            default:
                break;
        }
    }

    protected isDiuChengPai(commonCards: number[], code: number): boolean{
        if(commonCards.length < 2){
            return false
        }

        let card = Card.makeCardByCode(code)
        let indexMap = {}
        let indexMap1 = {}
        let colorCount = 0
        for (let index = 0; index < commonCards.length; index++) {
            const tmpCode = commonCards[index];
            let tmpCard = Card.makeCardByCode(tmpCode)            
            indexMap[tmpCard.index] = indexMap[tmpCard.index] || []
            indexMap[tmpCard.index].push(tmpCard)
            if(tmpCard.color == card.color){
                colorCount++
                indexMap1[tmpCard.index] = true
                indexMap1[tmpCard.logicIndex] = true
            }
        }

        
        if(indexMap[card.index] && indexMap[card.index].length >= 2){
            return true
        }
        if(colorCount < 2){
            return false
        }

        let tmpList = [card.index - 2, card.index -1, card.index + 1, card.index + 2]
        if(indexMap1[tmpList[0]] && indexMap1[tmpList[1]]){
            return true
        }
        if(indexMap1[tmpList[1]] && indexMap1[tmpList[2]]){
            return true
        }
        if(indexMap1[tmpList[2]] && indexMap1[tmpList[3]]){
            return true
        }

        tmpList = [card.logicIndex - 2, card.logicIndex -1, card.logicIndex + 1, card.logicIndex + 2]
        if(indexMap1[tmpList[0]] && indexMap1[tmpList[1]]){
            return true
        }
        if(indexMap1[tmpList[1]] && indexMap1[tmpList[2]]){
            return true
        }
        if(indexMap1[tmpList[2]] && indexMap1[tmpList[3]]){
            return true
        }
        return false
    }

    protected canRaise(commonCards: number[], handCards: number[]): boolean{
        if(!commonCards || commonCards.length == 0 || !handCards || handCards.length == 0){
            return false
        }
        let codeList = commonCards.concat(handCards)        
        return this.isSameIndex(codeList) || this.isSameColorSequence(codeList)
    }

    protected canStorage(handCards: number[]): boolean{                
        return this.isSameIndex(handCards) || this.isSameColorSequence(handCards)
    }

    protected canAttach(areaCards: number[], handCard: number): boolean{
        if(!areaCards || areaCards.length < 3 || !handCard){
            return false
        }
        let codeList = areaCards.concat([handCard])
        return this.isSameIndex(codeList) || this.isSameColorSequence(codeList)
    }

    protected isSameColorSequence(codeList: number[]){
        if(!codeList || codeList.length < 3 || codeList.length > 13){
            return false
        }
        let cardList: Card[] = []
        let color = null
        for (let index = 0; index < codeList.length; index++) {
            const code = codeList[index];
            let card = Card.makeCardByCode(code)
            if(color && color != card.color){
                return false
            }
            color = card.color
            cardList.push(card)
        }
        cardList.sort(function(a, b){
            return a.index - b.index
        })
        let firstIndex = 0
        let isSequence = true
        for (let i = 0; i < cardList.length; i++) {
            const card = cardList[i];
            if(firstIndex && card.index != firstIndex + i){
                isSequence = false
                break
            }
            if(!firstIndex){
                firstIndex = card.index
            }
        }
        if(isSequence){
            return true
        }
        cardList.sort(function(a, b){
            return a.logicIndex - b.logicIndex
        })

        let firstLogicIndex = 0
        for (let i = 0; i < cardList.length; i++) {
            const card = cardList[i];
            if(firstLogicIndex && card.logicIndex != firstLogicIndex + i){
                return false
            }
            if(!firstLogicIndex){
                firstLogicIndex = card.logicIndex
            }
        }
        return true
    }

    protected isSameIndex(codeList: number[]){
        if(!codeList || codeList.length < 3 || codeList.length > 4){
            return false
        }
        let firstIndex = 0
        for (let i = 0; i < codeList.length; i++) {
            const code = codeList[i];
            let index = Card.codeToIndex(code)
            if(firstIndex && firstIndex != index){
                return false
            }
            firstIndex = index
        }
        return true
    }

    protected getNodeWorldPos(node: cc.Node){
        return node.parent.convertToWorldSpaceAR(node.position)
    }

    protected send_ack(){
        this.model.send_ack_req(this.m_ack_id)
    }


    protected on_msg_err(errNo: number){

    }

    protected removeCodesFromList(codeList: number[], targets: number[]){
        targets = targets.concat()
        let tmpMap = {}
        for (let index = 0; index < targets.length; index++) {
            let code = targets[index];
            code = Card.codeToLogicCode(code)
            tmpMap[code] = tmpMap[code] || 0
            tmpMap[code]++
        }
        for (let i = 0; i < codeList.length; ) {
            let code = codeList[i];
            code = Card.codeToLogicCode(code)            
            let include = tmpMap[code]            
            if(include && include > 0){
                tmpMap[code]--
                codeList.splice(i, 1)
            }else{
                i++
            }
        }
    }


    protected isLocalSeatPosSequence(pos1: number, pos2: number, maxPlayerCount: number){   
        if(pos1 == pos2){
            return false
        }
        let count = pos2 - pos1 - 1
        if(pos1 > pos2){
            count = pos2 + maxPlayerCount - pos1 - 1
        }
        for (let index = 1; index <= count; index++) {
            let pos = (pos1 - 1 + index) % maxPlayerCount            
            let tmpSeatInfo = this.getSeatInfoByRemotePos(pos + 1)                        
            if(tmpSeatInfo && tmpSeatInfo.playerId != 0){
                return false
            }
        }
        return true
    }


    onLeaveRoomSuccess(isKick?: boolean) {
        //断开连接
        this.closeServerConnect()
        //回到大厅界面
        SceneManager.gotoHallOrClubHall("TabelExit");               
    }

    protected on_click_player_avatar(avatar: TablePlayerAvatar){
        super.on_click_player_avatar(avatar)
        let self = this
        let roomInfo = self.getRoomInfo() as Q2RoomInfo
        self.m_last_show_module_fun = function(){
            self.on_click_player_avatar(avatar)
        }
        if(roomInfo.currentSeat == roomInfo.mySeatInfo.remotePos){
            self.m_need_show_module_fun = self.m_last_show_module_fun
            self.doScheduleOnce(function(){
                ModuleManager.instance.hideModule("ChatInfo")
                ModuleManager.instance.hideModule("OhterChatInfo")
            }, 0.5)
        }
    }

    protected isAutoLeaveOnEnd(){
        return ModelData.instance.tableCommonData.autoLeaveWhenGameEnd
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let data = LoaclStorage.getJson('q2_auto_leave_on_end')
        if(!data){
            return false
        }
        if(!data.roomId || data.roomId != roomInfo.roomId){
            return false
        }
        return true
    }

    protected setAutoLeaveOnEnd(autoLeave: boolean){
        return
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let key = ('q2_auto_leave_on_end')
        let data: any = {}
        if(autoLeave){
            data.roomId = roomInfo.roomId
            
        }
        LoaclStorage.setJson(key, data)
    }

    protected cleanDesk(cleanScore?: boolean){
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let seatInfoList = roomInfo.seatInfoList

        this.view.deskCards.showPokers(false)
        this.view.showPokerHeap(false)
        this.view.mySeatCards.showPokers(false)
        this.view.showDirectionIcon(false, 0)
        this.view.showRaiseBtn(false)
        this.view.showMoreCardBtn(false)
        this.view.showAttachBtn(false)
        this.view.showStorageBtn(false)
        this.view.showDiscardBtn(false)
        this.view.showShowQ2Btn(false)
        this.view.showQuickHuBtn(false)
        this.view.showSortCardsBtn(false)
        this.view.showConfirmBtn(false)
        this.view.showCancelBtn(false)
        this.view.showRecordLabel(false)
        this.view.showHintBtn(false)

        for (let index = 0; index < seatInfoList.length; index++) {
            const seatInfo = seatInfoList[index];
            if(seatInfo.localPos != 0){
                this.view.showSeatHandCards(seatInfo.localPos, false)
                this.view.showSeatHandCardsBg(seatInfo.localPos, false)
            }   
            this.view.showAreaCards(seatInfo.localPos, false, [])  
            this.view.showSeatSelected(seatInfo.localPos, false)  
            this.view.showSeatWatchTag(seatInfo.localPos, false)     
            if(cleanScore){
                this.view.showSeatScore(seatInfo.localPos, seatInfo.playerId != 0, 0)
            }
        }

        this.view.showPokerRecorder(false, false, true)
    }
}

